import React, { useEffect, useRef, useState ,useContext} from "react";
import { Theme, useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Icon,
  Checkbox,
  Chip,
  FormControlLabel,
  Link,
  Tooltip,
  Typography,
  PropTypes,
  IconButton,
  ListItemIcon,
  TextField,
  MenuItem,
  Grid,
  Popover,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
  InputLabel,
  Select,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Backdrop,
  CircularProgress,
  Alert,
  AlertTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack
} from "@mui/material";
import GroupIcon from '@mui/icons-material/Group';
import WarningIcon from '@mui/icons-material/Warning';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ListIcon from "@mui/icons-material/List";
import TableAbstraction, { TableAbstractionColumn } from "../../componentUtils/TableAbstraction";
import Inventory from "./Inventory";
import Activity from "./Activity";
import DateAct from "./DateAct";
import Route from "./Route";
import PlanningMapView from "./PlanningMapView";
import CircularLoadButton, { LoadingStatus } from "../../components/LoadingButton";
import {
  getPlanningSettlement,
  setPlanningStatus,
  resetPlanningStatus,
  setPlanningActivity,
  setPlanningFTC,
  setPlanningRoute,
  replanUpdate,
  updateDate,
  setbulkUnSchedule,
  setbulkSchedule, 
  loadReportGenerate,
  customerPDFGenerate,
  HistoryPdf,
  pdfDeleteByRoute,
    GetRouteReset,
    resetRoutePlan,
    saveReviewData,
    deleteReviewData,
    updateReadyToReviewStatus,
    getReadyToReviewStatus
} from "../../utils/GetPlanning";
import { essentialData } from "../../utils/GetEssentialData";
import moment from "moment";
import { useLocalStorage } from "../../componentUtils/LocalStorage";
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna";
import { PlanningState, MatDetail, PlanningItem } from "./index";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import NoTransferIcon from "@mui/icons-material/NoTransfer";
import AddAlert from "@mui/icons-material/AddAlert";
import UndoIcon from "@mui/icons-material/Undo";
import MapIcon from "@mui/icons-material/Map";
import SyncIcon from '@mui/icons-material/Sync';
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Clear from "@mui/icons-material/Clear";
import MarkChatReadRounded from '@mui/icons-material/MarkChatReadRounded';

import { GridFilterItem, GridFilterInputValue, GridColDef, MuiEvent,GridFilterModel } from "@mui/x-data-grid-pro";
import OverLayPlanningMapView from "./OverLayPlanningMapView";
import { useHistory } from "react-router-dom";
import { tooltip } from "leaflet";
import InfoIcon from "@mui/icons-material/Info";
import { GetStatusBadge } from "src/components/request/requestUtils";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import PageInPage from "src/componentUtils/PageInPage";
import VendPrimeRequest from "../VendPrime/VendPrimeRequest";
import { formatDate } from "src/utils/Formatter";
// import { DatePicker, LocalizationProvider } from "@mui/lab";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import SheduledRoute from './SheduledRoute'
import {
  // Delete,
  // Save,
  NoteAdd,
} from "@mui/icons-material";
import { GetNotes, CustomerNotes, noteMeta } from "src/utils/GetCustomer";
import { PostNotes } from "src/utils/PostCustomer";
import { useParams } from "react-router-dom";
import dateFormatter from "src/utils/DateFormatter";
import { Box, fontSize, minWidth } from "@mui/system";
import { color, pointer } from "d3";
import load_report_pdf from "src/utils/load_report_pdf";
import build_route_pdf from "src/utils/route-card-pdf";
import { SoketContext, DisplayRoleContext } from "../../Context_api";
import {GetEssentialData} from "../../utils/GetEssentialData";
import _, { forEach, set } from "lodash";

let scheduleList:any = []
let unscheduleList:any = []

const Pointer = {cursor: 'pointer',margin:'10px'};
const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  tablediv: {
    marginTop: theme.spacing(1),
  },
  planView: {
    position: "relative",
  },
  tooltip: {
    margin: 0,
    padding: 0,
    li: {
      margin: 0,
      padding: 0,
    },
  },
  header: {
    display: "none",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalGrid: {
    marginTop: theme.spacing(2),
  },
  modalTitle: {
    color: theme.palette.primary.main,
  },
  modalCard: {},
  modalText: {
    width: 800,
  },
  modalInput: {
    paddingLeft: "2px",
    paddingRight: "20px",
    width: "200px",
  },
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid`,
    borderColor: theme.palette.border.main,
    boxShadow: theme.shadows[4],
    padding: theme.spacing(2, 2, 2),
  },
  paragraphButton: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  gridSpaceable: {
    padding: theme.spacing(0),
    margin: theme.spacing(0),
  },
  gridMarginTop: {},
  ulNoBullets: {
      listStyleType: "none",
      padding: 0,
      margin: 0
    }
}));
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
interface Inputs {
  data: PlanningState;
  change: any;
  changeAll: any;
  reloadAll: any;
  isLoading: boolean;
  reloadHeaderStatus: any;
  salesOrg:any,
  plant:any
  saveDraft:any,
  futureSusWrnDay:any,
  routesSelected:any;
  alertClearRoute:any;
  setAlertClearRoute:any;
  setRouteEvent:any;
  setSalesOrgEvent:any;
  setRefresh : any
  SessionCustomerList:any
  addSessionCustomer:any
  session:any
}


interface Grouping {
  customerNums: string[];
  name: string[];
  location: string[];
  coordinates: number[];
}

export interface DetailState {
  planningItem: PlanningItem | null;
  matDetails: MatDetail[];
  settlementData: any;
  salesOrg:string;
}
export interface DetailMapState {
  planningItems: any;
  sameCoordinates: any[];
}

interface ColumnSort {
  name: string;
  direction: string;
}
interface Data {
  currentStatus: any[];
  schedule: any[];
  accessDays: string[];
  salesDays: string[];
  act: string[];
}
interface alertFields{
  alertTitle:any;
  alertMessage:any;
  alertProceedButton:any;
  alertDenyButton:any;
  alertDisable:boolean;
  isAlertOpen:boolean;
}

export default function Planning(props: Inputs) {
  const {broadcast,postmessage,uuid,is_active,setActive,postSoket}:any = useContext(SoketContext);
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);

    //const [session_message, setSession_message] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const theme = useTheme();
  const classes = useStyles();
  const elementRef = useRef(null);
  const history = useHistory();
  const [detail, setDetail] = React.useState<DetailState>({
    planningItem: null,
    matDetails: [],
    settlementData: {},
    salesOrg:'',
  });
  const [mapDetail, setMapDetail] = React.useState<DetailMapState>({
    planningItems: [],
    sameCoordinates: [],
  });
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const[isDownloadRoutecard,setIsDownloadRoutecard]=useState<boolean>(false)
  const[isMapClicked,setIsMapClicked]=useState<boolean>(false)
  const [showInv, setShowInv] = useState(false);
  const [showPlanMapView, setShowPlanMapView] = useState(false);
  const [modeValue, setModeValue] = useState("Normal");
  const [displayCol, setDisplayCol] = useLocalStorage("SETTINGS.PBDisplayableColumns", new Array<string>());
  const [displayColumnsLS, setDisplayColumnsLS] = useLocalStorage<{ [key: string]: boolean }>(
    "SETTINGS.VS_PLN_displayableColumns",
    {}
  );
  const [colSequence, setColSequence] = useLocalStorage("SETTINGS.PBColSequence", new Array<number>());
  const [rowsPerPage, setRowsPerPage] = useState(500);
  const [colSort, setColSort] = useState<any[]>([{ name: "sort", direction: "asc" }]);
  const [activity, setActivity] = useState(-1);
  const [dateAct, setDateAct] = useState(-1);
  const [route, setRoute] = useState(-1);
  const [customerNotesPopup, setCustomerNotesPopup] = useState<boolean>(false);
  const [customerNotes, setCustomerNotes] = useState<any[]>([]);
  const [routePopup, setRoutePopup] = useState<boolean>(false);
  // const[isDisabled, setDisabled]  = useState(false);
  const [hoveredNoteType, setHoveredNoteType] = useState<string>("");
  //const state = props.data;
  const [state, setState] = useState<any>({ ...props.data });
  const [susFutDt, setSusFutDt] = useState(props.futureSusWrnDay);
  const [statusOflist, setStatusOflist] = useState(0);
  const [hasScheduledVisit, setHasScheduledVisit] = useState<boolean>(false);
  const [codes, setCodes] = React.useState<any>();
  const [displayPIP, setDisplayPIP] = React.useState<boolean>(false);
  const [curKeys, setCurKeys] = React.useState<
    { requestNum: number; salesOffice: string; customerNum: string; customerName: string } | undefined
  >();
  const [vpRequests, SetVpRequests] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  //selected Rows
  const [selectedRoutes, setSelectedRoutes] = React.useState<any[]>([]);
  const [selectedRoutesCkecks, setSelectedRoutesCkecks] = React.useState<any[]>([]);
  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().setHours(12, 0, 0, 0));
  const [errorMessage, setErrorMessage] = useState<{ title: string; message: string } | undefined>(undefined);
  const initialSelectedOptions = {
    noteType: "CUSTOMER",
    text: "",
    isDeleted: false,
    isImportant: false,
    createdDt: new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(12, 0, 0, 0)),
    validUntilDt: new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(23, 59, 59, 0)),
    createdBy: "",
  };
  const [selectedOptions, setSelectedOptions] = React.useState<any>(initialSelectedOptions);
  const [selectedCustomer, setSelectedCustomer] = React.useState<any>("");
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
  const [notes, setNotes] = React.useState<any>([]);
  const [hoverCustomerNotes, setHoverCustomerNotes] = React.useState<any>([]);
  const [editNote, setEditNote] = React.useState<boolean>(false);
  let savingActive=false;
  let savingCustNum='';
  //let bulkItems=new Map()
  const [bulkItems, setbulkItems]= useState<any[]>([]);
  const [bulkshedule, setbulkshedule]= useState<boolean>(false);
  // const [bulkUnshedule, setUnbulkshedule]= useState<boolean>(false);
  const [routeCustomerNum, setRouteCustomerNum] = useState<any>([]);
  const [handleConfirmRoutes, setHandleConfirmRoutes] = useState<any>(null);
  const [handleDate,setHandleDate]=useState(false);
  const [alert,setAlert]=useState("");
  const [clearRoutesAlert,setClearRoutesAlert]=useState(false);
  const [showLoader,setShowLoader]=useState(false);

  const [shedule, setShedule] = useState(false);
  const [confirmRouteReset, setConfirmRouteReset] = React.useState<boolean>(false);
  const [routeBatchItem, setRouteBatchItem] = useState<any>([]);
  const [adminSettingEnable, setAdminSettingEnable] = React.useState(0);
  const [confirmBatchRouteReset, setConfirmBatchRouteReset] = React.useState<boolean>(false);
  const [routeItem, setRouteItem] = useState<any>([]);
  const [routeItemIndex, setRouteItemIndex] = useState<any>();

  const[alertResetRoutePlan,setAlerResetRoutePlan]=useState<boolean>(false)



  
  const notesRef=useRef<any>('');
  const reviewCommentRef=useRef<any>('');
  const [errorRouteMessage, setErrorRouteMessage] = useState({ "validate": true,
  "message":''});
    const [sheduleObj, setSheduledObj] = useState<any>([]);
  const [alertReplan,setAlertReplan]=useState(false);
  const [commonAlert,setCommonAlert]=useState<alertFields>({alertTitle:'',alertMessage:'',alertProceedButton:false,alertDenyButton:false,alertDisable:false,isAlertOpen:false});

  const [essData, setEssData] = useState<essentialData>();

  const [tabIndex, setTabIndex] = useLocalStorage("SETTINGS.CP_tabIndex", 0);
  const [customerLoaded, setCustomerLoaded] = useLocalStorage<string>("SETTINGS.CP_customerNum", "");

  const [gridTableLoader, setGridTableLoader] = useState<boolean>(false);
  const [planningDataStore, setPlanningDataStore] = useState<any>([]);
  const [isReviewFeatureEnabled, setIsReviewFeatureEnabled] = useState<boolean>(false);
  const [reviewDialog, setReviewDialog] = useState<boolean>(false);
  const [reviewDialogData, setReviewDialogData] = useState<any>({});
  const [enableReadyToReview, setEnableReadyToReview] = useState<any>(false);
  const [readyToReviewStatusValue, setReadyToReviewStatusValue] =  useState<any>();
  const [initailStateOfReviewObj, setInitailStateOfReviewObj] =  useState<any>();
  const [reviewChangeRouteDialog, setReviewChangeRouteDialog] = React.useState<boolean>(false);
  const [isReviewChangeRouteConfirm, setIsReviewChangeRouteConfirm] = React.useState<boolean>(false);
  const [enableReviewSaveButton, setEnableReviewSaveButton] = React.useState<boolean>(false);
  
  /**
   * Adding code for display or read only mode
   */

  //const [displayOnlyRole, setDisplayOnlyRole] = useState<boolean>(true);


  useEffect(() => {
    setDisabled(props.session.is_disable);
    setReadyToReviewStatusValue(undefined);
  }, [props.session, is_active])

    useEffect(()=>{
      if(selectedRoutes.length>0){
        props.setAlertClearRoute(false);
        setClearRoutesAlert(true);
      }
    },[props.alertClearRoute])

    const [isOverdueMachine, setIsOverdueMachine] = useState(false);

  useEffect(() => {
      savingActive=false;
      savingCustNum='';
      const v = {notes : essData?.msg?.notes, releaseDrafts: essData?.msg?.routeconfig || [], reviewConfig: essData?.msg?.reviewconfig || []}
      const result = v?.notes?.reduce((result: any, currentValue: any) => {
      (result[currentValue?.customerNum] = result[currentValue?.customerNum] || []).push(currentValue);
      return result;
      }, {});
      
      setNotes(result);
      
      if(v.releaseDrafts?.length>0 && v.releaseDrafts[0]){
          setAdminSettingEnable(v?.releaseDrafts[0]?.param_value);
      }
      
      if(v.reviewConfig?.length  && v.reviewConfig[0].param_value == 1){
        setIsReviewFeatureEnabled(true);
      }
    }, [essData]);

  useEffect(() => {
    requestMissingContexts(["SALESOFFICES", "vp_req_status"]).then((v) => {
      // console.log("----->", v);
      setCodes(v);
    });

    SetVpRequests(state.planningData);
  }, [state.planningData, salesOrg]);

  useEffect(() => {
    sessionStorage.setItem("selectedRoute",'');
    sessionStorage.setItem("selectedDeliveryPlant",'');
    setStatusOflist(0);
    setHasScheduledVisit(false);
    // props.reloadHeaderStatus();
    // setMapDetail({planningItems: state.planningData, sameCoordinates: []});
   // props.data.planningData=new Date(selectedDate)
    setState({ ...props.data });
    setSusFutDt(props.futureSusWrnDay);
    filterStatus(props.data.planningData);
    const customersNotesData:any = [];
    let checkToEnableReayToReview: boolean = false;
  
    for(let i=0; i<props?.data?.planningData.length;i++){
            let tempCustomerNotes: any = []; //= props.data.planningData[i]?.ishistory ? props.data.planningData[i]?.notes : props.data.planningData[i]?.customerNotes;
            if(props.data.planningData[i]?.ishistory){
              tempCustomerNotes = props.data.planningData[i]?.notes ? JSON.parse(props.data.planningData[i]?.notes) : [];
              tempCustomerNotes.map((ele: any)=> ele.customerNum = props.data.planningData[i]?.customerNum);
            }else{
              tempCustomerNotes = props.data.planningData[i]?.customerNotes || [];
            }
            customersNotesData.push(...tempCustomerNotes);
            const planningDate = props.data.planningDate?.toISOString()?.split("T")[0];
            const nextDelAct = props.data.planningData[i]?.nextDeliveryAct ? 
            new Date(Date.parse(props.data.planningData[i]?.nextDeliveryAct))?.toISOString()?.split("T")[0] : '';
            let scheduledDates = [];
             for (let j=0; j<props.data.planningData[i]?.sheduled?.length; j++){
               scheduledDates?.push(props.data.planningData[i]?.sheduled[j]?.visit_dt_plan);
             }
             const closestDate = getPreviousSheduledList(scheduledDates,planningDate);
             const currentPlDate:any = new Date(planningDate);
             let clstDate:any = new Date(closestDate);
             let clstDateDiff = Math.ceil(Math.abs(clstDate - currentPlDate)/(1000 * 60 * 60 * 24));
            
             const lastDelDate:any = new Date(props.data.planningData[i]?.lastDelivery);
             let lastDeliverydiff = Math.ceil(Math.abs(lastDelDate - currentPlDate)/(1000 * 60 * 60 * 24));
             
             //props.data.planningData[i].currentStatus = 'O';

             if (nextDelAct > planningDate && props.data.planningData[i]?.dri >= 0) {
              props.data.planningData[i].currentStatus = 'F';
             }

             if(lastDeliverydiff > 60  && clstDateDiff > 60){
              props.data.planningData[i].currentStatus = 'O';
            }
             

             if(props.data.planningData[i]?.sheduled?.length == 0 && new Date(props.data.planningData[i]?.nextDeliveryAct) > new Date(planningDate) && props.data.planningData[i]?.dri < 0) {
              props.data.planningData[i].currentStatus = 'O';
             }

             if (props.data.planningData[i].nextDeliveryAct <= planningDate) {
             if(props.data.planningData[i].status === 'P'){
             props.data.planningData[i].currentStatus = 'O';
             }
             }

             if (props.data.planningData[i]?.nextDeliveryAct === planningDate) {
              if (props.data.planningData[i]?.status === "S") {
                props.data.planningData[i].currentStatus = 'S';
              }
             }

             if(props.data.planningData[i]?.sheduled?.length > 0 && new Date(props.data.planningData[i]?.nextDeliveryAct) > new Date(planningDate)) {
              props.data.planningData[i].currentStatus = 'S';
             }

      

             if (props.data.planningData[i].status === "S") {
              props.data.planningData[i].currentStatus = 'S';
      
            
             }

             if (props.data.planningData[i].status === "C") {
                 props.data.planningData[i].currentStatus = 'C';
             }

             //if there is any schedule for selected planning date then make Ready To Review button
              if(!checkToEnableReayToReview && props.data.planningData[i].status === "S"){
                checkToEnableReayToReview =true;
              }


            //  console.log('CurrentStat',props.data.planningData[i].currentStatus,
            //   '----' + props.data.planningData[i].customerNum + '-----' + (props.data.planningData[i]?.nextDeliveryAct) + '------' + planningDate
             //);
             
    }
    const result = customersNotesData.reduce((result: any, currentValue: any) => {
      (result[currentValue?.customerNum] = result[currentValue?.customerNum] || []).push(currentValue);
      return result;
    }, {});
    setNotes(result);
    if (props.isLoading) {
      setShowPlanMapView(false);
    }
      setEnableReadyToReview(checkToEnableReayToReview);
      setSelectedRoutesCkecks([]);
      setbulkItems([]);
      scheduleList = []
      unscheduleList = []
      setbulkshedule(false);
     // setUnbulkshedule(false);
     setDisabled(false);
  }, [props.data,props.futureSusWrnDay]);

  useEffect(()=>{
    //get latest  ready to review status value
    const payload: any = {
        salesOrg,
        deliveryPlant: state?.selectedDeliveryPlant,
        route: state?.selectedRoute,
        loadDate: state?.planningDate?.toISOString()?.split("T")[0],
      }
    if(payload.route && payload.deliveryPlant && payload?.loadDate &&  payload?.loadDate >= new Date().toISOString().split('T')[0]){
      getReadyToReviewStatus(salesOrg, payload).then((updatedReviewStatusValue: any)=>{
        if(updatedReviewStatusValue && updatedReviewStatusValue.length){
          setReadyToReviewStatusValue(updatedReviewStatusValue[0]?.reviewStatusValue);
        }else{
          setReadyToReviewStatusValue(1);
        }
      });
    }
  },[state?.selectedRoute, state?.planningDate]);

  //
  useEffect(()=>{
    if(isDisplayOnlyRole){
      const clonedReviewDialogData = {...reviewDialogData};
      if(clonedReviewDialogData?.schedulePlan == clonedReviewDialogData?.initialStatus && clonedReviewDialogData?.activityPlan == clonedReviewDialogData?.initialActivity
        && clonedReviewDialogData?.routePlan == clonedReviewDialogData?.initialRoute && clonedReviewDialogData?.ftcPlan == clonedReviewDialogData?.initialFTC
      ){
        setEnableReviewSaveButton(true);
      }else{
        setEnableReviewSaveButton(false);
      }
    }
  }, [reviewDialogData]);



  function formatDate(date: Date) {
    var d = new Date(date),
      month = "" + (d.getUTCMonth() + 1),
      day = "" + d.getUTCDate(),
      year = d.getUTCFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    // console.log("🚀 ~ file: Planning.tsx ~ line 162 ~ handlePopoverOpen ~ event", event);
    setAnchorEl(event.currentTarget);
    //  setCustomerNotesPopup(true)
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    //  setCustomerNotesPopup(false)
  };
  const open = Boolean(anchorEl);


  // console.log("🚀 ~ file: Planning.tsx ~ line 600 ~ Planning ~ selectedRoutes", selectedRoutes);

  const filterStatus = (data: any) => {
    if (data.length > 0) {
      
      const planningDate =props.data.planningDate?.toISOString()?.split("T")[0];
      data.map((res: any) => {
        if (res.status === "C" && res.nextDeliveryAct === planningDate) {
          setStatusOflist(1);
        }
        if (res.status === "S" && res.nextDeliveryAct === planningDate) {
          setHasScheduledVisit(true);
        }
      });
    }
  };

  const handleReleaseReady = () => {
    // console.log("Save to Draft");
    props.saveDraft();
  };

  

  const sheduleBtn = (scheduledObj: any, dataIndex: number) => { 
    const isMultCustomer = props.data.planningData[dataIndex].activity==="MULT"
    if (isMultCustomer) {
      const alert={
        alertTitle:'Change Route Alert',
        alertMessage:'Please uncheck the customers with activity MULT and update sap with one activity correctly.',
        isAlertOpen:true,
        alertProceedButton:false,
        alertDenyButton:false,
        alertDisable:false,
      };
      return setCommonAlert(alert)
    }
    setShedule(true);
    setSheduledObj(scheduledObj);
  };
  const handleSheduleClose = () => {
    setShedule(false)
  };
  /***
   *
   * Table shedule btn  handler
   *
   */

  const handleStatusClick = (item: PlanningItem, dataIndex: number, e: React.MouseEvent<HTMLButtonElement>) => {
    //Send  Message
    e.preventDefault();
    //if it is a display only role, do not do anything just return;
    if(isDisplayOnlyRole){
      return;
    }
    if (item.activity==="MULT") {
      const alert={
        alertTitle:'Schedule Alert',
        alertMessage:'Update sap with one activity correctly to proceed.',
        isAlertOpen:true,
        alertProceedButton:false,
        alertDenyButton:false,
        alertDisable:false,
      };
      return setCommonAlert(alert)
    }
    const clone = JSON.parse(JSON.stringify(item));
        if(clone.status!='C'){
          clone['history']={}
          let cus:any=RenderCustomer(item);
          clone.history["customer_status"]=cus?.props.id || '';
          clone.history["customer_msg"]=cus?.props.title || '';
          let exe_status=RenderExceeded_Status(item)  
          if(exe_status){
            if(exe_status=='DexErrors_Exceeded'){
              clone.history["exceeded_status"]='DexErrors_Exceeded'
            }
            else{
              clone.history["exceeded_status"]=exe_status
            }
          }else{
            clone.history["exceeded_status"]=null
          }

            let online = RenderOnline(item);
            if(online){
              clone.history["online"]=online?.props?.children?.props?.id ;
              clone.history["online_msg"]=online?.props?.children?.props?.title;
            }
            else{
              clone.history["online"]=null;
              clone.history["online_msg"]=null
            }
           
      let statuss= RenderStatus(item) ;
 
      if(statuss){
        clone.history["status_msg"]=statuss?.props.title || '';;
       }    
      }
      clone["nfk"] = !clone.online ? 2 :(clone.online && clone.isFKMissed) ? 1 : 0;

      if(!savingActive){
        sheduleAction(clone, dataIndex);
}
      
    
        // setDisabled(true);
    // item.loading = true;
    // var newStatus = "P";
    // var newDate = new Date(state.planningDate);
    // var isValid = false;

    // // what is the current status?
    // if (item.status === "P" || item.status === "C") {
    //   newStatus = "S";
    //   isValid = true;
    // }
    // if (item.status === "S") {
    //   // this item is already scheduled. If we are planning for another day, change the date. If not, unschedule it
    //   if (item.nextDeliveryAct === state.planningDate.toISOString().split("T")[0]) {
    //     newDate = new Date(item.nextDeliveryPlan);
    //     newStatus = "P";
    //   } else {
    //     newStatus = "S";
    //   }
    //   isValid = true;
    // }
    // if (isValid) {
    //   const customerArr = [item.customerNum];
    //   const actData = {
    //     salesOffice: state.selectedSalesOffice,
    //     route: item.routeAct,
    //     loadDate: item.nextDeliveryAct,
    //     customerNum: item.customerNum,
    //     equipmentNum: item.equipmentNum
    //   };
    //   setPlanningStatus(salesOrg.toString(), customerArr, newStatus, newDate, actData).then((v: string) => {
    //     if (v) {
    //       // setDisabled(false);
    //       item.loading = false;
    //     }
    //     if (v === "S") {
    //       // update successful, now update local structure w/o reloading everything
    //       item.status = newStatus;
    //       item.nextDeliveryAct = newDate.toISOString().split("T")[0];
    //       props.change(item, dataIndex);
    //       // if(newStatus==="P"){
    //       //   props.reloadAll();
    //       // }
    //     }
    //   });
    // }
  };

  const handleScheduleTodayClick = () => {
    var newStatus = "S";
    var newDate = new Date(state.planningDate);
    var customerNums: any[] = [];
    var itemArr: PlanningItem[] = [];
	  let actData = {};
    const data : String [] = []

    for (var i = 0; i < state.planningData.length; i++) {
      var item = state.planningData[i];
      const clone = JSON.parse(JSON.stringify(item));
      if(clone.status!='C'){
        clone['history']={}
        let cus:any=RenderCustomer(item);
        clone.history["customer_status"]=cus?.props.id || '';
        clone.history["customer_msg"]=cus?.props.title || '';
        let exe_status=RenderExceeded_Status(item)  
        if(exe_status){
          if(exe_status=='DexErrors_Exceeded'){
            clone.history["exceeded_status"]='DexErrors_Exceeded'
          }
          else{
            clone.history["exceeded_status"]=exe_status
          }
        }else{
          clone.history["exceeded_status"]=null
        }

          let online = RenderOnline(item);
          if(online){
            clone.history["online"]=online?.props?.children?.props?.id ;
            clone.history["online_msg"]=online?.props?.children?.props?.title;
          }
          else{
            clone.history["online"]=null;
            clone.history["online_msg"]=null
          }
         
        let statuss= RenderStatus(item) ;

        if(statuss){
          clone.history["status_msg"]=statuss?.props.title || '';;
        }
      }

      if(item.nextDeliveryPlan && item.nextDeliveryPlan !=undefined){
      let nextDeliveryPlan=new Date(item?.nextDeliveryPlan).toISOString()?.split("T")[0];

      if ( nextDeliveryPlan=== state?.planningDate?.toISOString()?.split("T")[0]) {
        actData = {
          ...clone,
          plant: state.selectedDeliveryPlant,
          route: item.routeAct,
          loadDate: item.nextDeliveryAct,
          customerNum: item.customerNum,
          equipmentNum: item.equipmentNum,
          activity: item.activity,
        };
        if (canBeVisited(item.accessDays)) {
          customerNums.push(actData);
          data.push("")
          item.status = newStatus;
          item.nextDeliveryAct = newDate?.toISOString()?.split("T")[0];
        }

        
      }
    
      itemArr.push(item);
      }
    }
    if (customerNums.length > 0) {
      setShowLoader(true);
      setPlanningStatus(salesOrg.toString(), customerNums, newStatus, newDate, data ,uuid).then((v: string) => {

        setShowLoader(false);
        if (v === "S") {
          let Sarry:any=[...props.SessionCustomerList]
          if(Sarry.length>0){
            
        const index = Sarry.indexOf(5);
        if (index > -1) { // only splice array when item is found
          Sarry.splice(index, 1); // 2nd parameter means remove one item only
        }
        props.addSessionCustomer(Sarry)
        
          }
          // update successful, now update local structure w/o reloading everything
          props.changeAll(itemArr);
        }
     
      }).catch(err => {
        setAlert("Error while Schedule Planned")
        setShowLoader(false);
      });
    }
  };

  const handleUnscheduleAllClick = () => {
    var newStatus = "P";
    var newDate = new Date(state.planningDate);
    var customerNums: string[] = [];
    var itemArr: PlanningItem[] = [];
    for (var i = 0; i < state.planningData.length; i++) {
      var item = state.planningData[i];
      const dt = item.nextDeliveryAct.toString();
      if (dt === state?.planningDate?.toISOString()?.split("T")[0]) {
        customerNums.push(item.customerNum);
        item.status = newStatus;
        item.nextDeliveryAct = item.nextDeliveryPlan;
      }
      itemArr.push(item);
    }
    if (customerNums.length > 0) {
      resetPlanningStatus( state.selectedRoute,salesOrg.toString(), customerNums, newStatus, newDate,uuid).then((v: string) => {
        if (v === "S") {
          // update successful, now update local structure w/o reloading everything
         // props.changeAll(itemArr);
         props.reloadAll()
        }
      });
    }
  };

  const handleFTCClick = (item: PlanningItem, dataIndex: number, event: any) => {
    //if it is a display only role, do not do anything just return;
    if(isDisplayOnlyRole){
      event.prevenDefault();
      return;
    }
    let newFTC = !item.ftc;
    const planningDateStr = state?.planningDate?.toISOString()?.split("T")[0];
    setPlanningFTC(salesOrg.toString(), item.customerNum, item.equipmentNum, newFTC, item, planningDateStr,state.selectedDeliveryPlant, state.selectedRoute,uuid).then(
      (v: { response: string; planningItem?: PlanningItem }) => {
        if (v.response === "S") {
          // update successful, need to trigger reload
          if (v.planningItem) {
            const updatedPlanning: any = v.planningItem;
            if(updatedPlanning.sheduled.length){
              updatedPlanning.sheduled[0]["fill_to_capacity"] = newFTC;
            }
            props.change(updatedPlanning, dataIndex);
          } else {
            props.reloadAll();
          }
        }
      }
    );
  };

  const handleInvClick = (planningItem: PlanningItem) => {
    getPlanningSettlement(salesOrg.toString(), planningItem.customerNum).then((v: any) => {
     // console.log("v in planning board", v);
      setDetail({ planningItem, matDetails: state.matDetails, settlementData: v,salesOrg:salesOrg.toString() });
      setShowInv(true);
    });
  };

  const handleInvClose = () => {
    setShowInv(false);
  };

  const handlePlanMapViewClick = () => {
    if (state.planningData.length) {
      setIsMapClicked(true)
      setShowPlanMapView(!showPlanMapView);
    }


    //   const item = state.planningData;
    // let result = item.reduce(function (r:any, a:any) {
    //   r[a.latitude+','+a.longitude] = r[a.latitude+','+a.longitude] || [];
    //   r[a.latitude+','+a.longitude].push(a);

    //   return r;
    //   }, Object.create(null));
    //   setMapDetail({planningItems: state.planningData, sameCoordinates: result});
  };

  const handleRefreshClick = () => {
    setDisabled(false);
    setReadyToReviewStatusValue(undefined);
    // setSession_message(false)
    // setActive(false)
    props.setRefresh(true);

    }

    const handleResetClick = () => {
      setAlerResetRoutePlan(true)
    }

    const ResetRoutePlanProceed=()=>{
      const planningDateStr = state?.planningDate?.toISOString()?.split("T")[0];
      resetRoutePlan(salesOrg.toString(),state.selectedDeliveryPlant, state.selectedRoute, planningDateStr,uuid).then((v: string) => {
        if (v === "S") {
          props.reloadAll()
        }
      });
    }


  const handlePlanMapViewClose = () => {
    setShowPlanMapView(!showPlanMapView);
    setIsMapClicked(false)
  };

  const handleActClick = (rowIndex: number,activity:string,event:any) => {
    //if it is a display only role, do not do anything just return;
    if(isDisplayOnlyRole){
      event.prevenDefault();
      return;
    }
    if(activity!='INIT' && activity!='NOPH'){
      setActivity(rowIndex);
    }else{
       const alert={
        alertTitle:'Activity cannot be changed',
        alertMessage:'Activity cannot be changed, any needed update from NOPH or INIT should come from SAP',
        isAlertOpen:true,
        alertProceedButton:false,
        alertDenyButton:false,
        alertDisable:false,
      };
      return setCommonAlert(alert)
    }
  };

   const handleActSel = (newActivity: string) => {
    if (newActivity != "") {
      const dataIndex = activity;
      if (dataIndex > -1) {
        //setGridTableLoader(true);
        const planningDate = props.data.planningDate?.toISOString()?.split("T")[0];
        var item = state.planningData[dataIndex];
        
        setGridTableLoader(true);
        setPlanningActivity(salesOrg.toString(), item.customerNum, item.equipmentNum, newActivity, planningDate,state.selectedDeliveryPlant,state.selectedRoute,uuid).then(
          (v: string) => {
            if (v === "S") {
              // update successful, need to trigger reload
              //props.reloadAll();
              item["activity"] = newActivity;
              if(item.sheduled.length){
                item.sheduled[0]["activity"] = newActivity;
              }
              props.change(item,dataIndex);
            }
            setTimeout(()=> {setGridTableLoader(false)}, 500);
          }
        );
      }
    }
    setActivity(-1);
  };

  const handleModalClose = () => {
    setOpenEditWindow(false);
    setSelectedOptions(initialSelectedOptions);
  };

  const handleReviewModalClose = () => {
    setReviewDialog(false);
  };

  const handleReviewDataSave = async() => {
    //
    const reviewComments = reviewCommentRef?.current?.value;

    if(!reviewComments){
      const alert={
                alertTitle:'Review Alert',
                alertMessage:`Please provide the review comments for changes you have made.`,
                isAlertOpen:true,
                alertProceedButton:false,
                alertDenyButton:false,
                alertDisable:false,
              };

    return setCommonAlert(alert);
    }
    setShowLoader(true);
    setReviewDialog(false);
    try{
        const result: any = await saveReviewData(salesOrg, {...reviewDialogData, reviewComments});
        if(result && result.message ==="S"){
          //if it's a reviewwer role then marked the checkbox checked other wise keep it as unchecked
          
          const dataIndex = reviewDialogData?.dataIndex;
          let rowItem = state.planningData[dataIndex];
          let updatedReviewComment: any = [{ user_name: result?.userEmail  ,role_type: (isDisplayOnlyRole ? "reviwer" : "planner"), comments: reviewComments, timestamp: new Date().toISOString()}];
          if(rowItem?.txVisitPlanningReview?.length){
            const tempReviewComment: any = JSON.parse(rowItem?.txVisitPlanningReview[0]?.reviewComments);
            tempReviewComment.push(updatedReviewComment[0]);
            const sortedReviewComment = tempReviewComment.sort((a: any, b: any) => {
              const timestampA = new Date(a.timestamp).getTime();
              const timestampB = new Date(b.timestamp).getTime();
              return timestampB - timestampA;
            });
            updatedReviewComment = sortedReviewComment;
          }
          //pusing the temporary changes
          if(reviewDialogData?.schedulePlan !="P"){
            rowItem.txVisitPlanningReview = [{...reviewDialogData, active: true, reviewComments: JSON.stringify(updatedReviewComment)}]
          }else{
            const changedActivityPlan: string  = (reviewDialogData?.activityPlan == "NOPH" || reviewDialogData?.activityPlan == "INIT")? reviewDialogData?.activityPlan : "NORM";
            rowItem.txVisitPlanningReview = [{...reviewDialogData, activityPlan: changedActivityPlan, ftcPlan: false, active: true, reviewComments: JSON.stringify(updatedReviewComment)}]
          }
          
          if(isDisplayOnlyRole){
            rowItem.review = true;
          }
          props.change(rowItem, dataIndex);
        }
        setReviewDialog(false);
        setShowLoader(false);
        
      }catch(error: any){
        setReviewDialog(false);
        setShowLoader(false);
      }
  }

  const handleReviewDataDelete = async() => {
    //
    const alert={
                alertTitle:'Review Comments',
                alertMessage:'Review comment has been delete successfully',
                isAlertOpen:true,
                alertProceedButton:false,
                alertDenyButton:false,
                alertDisable:false,
              };
    //
    try{
      setShowLoader(true);
      setReviewDialog(false);
      await deleteReviewData(salesOrg, reviewDialogData);
      //if it's a reviewwer role then marked the checkbox checked other wise keep it as unchecked
      const dataIndex = reviewDialogData?.dataIndex;
      let rowItem = state.planningData[dataIndex];
      //pusing the temporary changes
      rowItem.txVisitPlanningReview = [];
      rowItem.review = false;
      props.change(rowItem, dataIndex);
      setReviewDialog(false);
      setReviewDialogData({});
      setReviewDialog(false);
      setShowLoader(false);
      return setCommonAlert(alert);
    }catch(error: any){
      setReviewDialog(false);
      setShowLoader(false);
    }
  }

   const handleReadyToReview = async() => {
    //
    let newReviewStatusValue =  readyToReviewStatusValue;
    try{
      setShowLoader(true);
      if(newReviewStatusValue ==1 && !isDisplayOnlyRole){
        newReviewStatusValue = 2;
      }else if(newReviewStatusValue ==2 && !isDisplayOnlyRole){
        newReviewStatusValue = 1;
      }else if(newReviewStatusValue ==2 && isDisplayOnlyRole){
        newReviewStatusValue = 3;
      }else if(newReviewStatusValue ==3){
        newReviewStatusValue = 2;
      }
      const payload: any = {
        salesOrg,
        deliveryPlant: state?.selectedDeliveryPlant,
        route: state?.selectedRoute,
        loadDate: state?.planningDate?.toISOString()?.split("T")[0],
        reviewStatus: newReviewStatusValue,
        uuid: uuid
      }
      const result: any = await updateReadyToReviewStatus(salesOrg, payload);
      //if it's a reviewwer role then marked the checkbox checked other wise keep it as unchecked
      if(result && result.message?.reviewStatus){
        setReadyToReviewStatusValue(newReviewStatusValue);
      }else{
        setReadyToReviewStatusValue(readyToReviewStatusValue);
      }
      setShowLoader(false);
    }catch(error: any){
      setReviewDialog(false);
      setShowLoader(false);
    }
  }

  const handleActClose = () => {
    setActivity(-1);
  };

  const handleDateActClick = (rowIndex: number) => {
    const isMultCustomer = props.data.planningData[rowIndex].activity==="MULT"
    if (isMultCustomer) {
      const alert={
        alertTitle:'Schedule visit Alert',
        alertMessage:'Unable to schedule visit customers with activity MULT and update sap with one activity correctly.',
        isAlertOpen:true,
        alertProceedButton:false,
        alertDenyButton:false,
        alertDisable:false,
      };
      return setCommonAlert(alert)
    }
    setDateAct(rowIndex);
  };

  const handleDateActSel = (obj: any) => {
    const newStatus = "S";
    const newDate = new Date(Date.parse(obj.date));
    const dataIndex = dateAct;
    let item:any ={}
    if(obj.item.is_table==true){
      item=state.planningData[dataIndex];
    }else{
     
      let planningFilter:any= state.planningData.filter((item:any) =>  item.customerNum===obj.item.customer_num);
      
      item=planningFilter[0]
      item.nextDeliveryAct=obj.item.visit_dt_plan

    }
    
    if (item && newDate) {
      const customerArr = [item.customerNum];
      // setPlanningStatus(salesOrg.toString(), customerArr, newStatus, newDate).then((v: string) => {
      //   if (v === "S") {
      //     // update successful, now update local structure w/o reloading everything
      //     item.status = newStatus;
      //     item.nextDeliveryAct = newDate.toISOString().split("T")[0];
      //     props.change(item, dataIndex);
      //   }
      // });

item.visit_dt_plan=item.nextDeliveryAct;
item.equipment_num=item.equipmentNum;
item.route_act=item.routeAct;
const clone = JSON.parse(JSON.stringify(item));
if(clone.status!='C'){
  clone['history']={}
  let cus:any=RenderCustomer(item);
  clone.history["customer_status"]=cus?.props.id || '';
  clone.history["customer_msg"]=cus?.props.title || '';
  let exe_status=RenderExceeded_Status(item)  
  if(exe_status){
    if(exe_status=='DexErrors_Exceeded'){
      clone.history["exceeded_status"]='DexErrors_Exceeded'
    }
    else{
      clone.history["exceeded_status"]=exe_status
    }
  }else{
    clone.history["exceeded_status"]=null
  }

    let online = RenderOnline(item);
    if(online){
      clone.history["online"]=online?.props?.children?.props?.id ;
      clone.history["online_msg"]=online?.props?.children?.props?.title;
    }
    else{
      clone.history["online"]=null;
      clone.history["online_msg"]=null
    }
   
let statuss= RenderStatus(item) ;

if(statuss){
clone.history["status_msg"]=statuss?.props.title || '';;
} 
clone.history["plant"]=props.data.selectedDeliveryPlant   


}
      updateDate(salesOrg.toString(), customerArr, new Date(newDate),item.nextDeliveryAct,item.routeAct,clone,uuid).then((v: string) => {
        setSheduledObj({
          salesOrg:props.salesOrg,
          route:item.routeAct,
          customer_num:item.customerNum,
          salesOffice:props.plant
        })
        props.setRefresh(true);
      });
    
    setDateAct(-1);
  }
  };

  const handleDateActClose = () => {
    setDateAct(-1);
    
  };

  const handleRouteClick = (rowIndex: number,customerNumber:any,salesOrg:any,planningDate:any, event:any) => {
    //if it is a display only role, do not do anything just return;
    if(isDisplayOnlyRole){
      event.prevenDefault();
      return;
    }
  const item = state.planningData[rowIndex];
  if (item.activity ==="MULT" ) {
    const alert={
      alertTitle:'Change Route Alert',
      alertMessage:'Please uncheck the customers with activity MULT and update sap with one activity correctly.',
      isAlertOpen:true,
      alertProceedButton:false,
      alertDenyButton:false,
      alertDisable:false,
    };
    return setCommonAlert(alert)
  }
    if (item.status != "C") {
      setRoute(rowIndex);
      setRouteCustomerNum([salesOrg,customerNumber,planningDate]);
    }

    return setRoutePopup(true)
  };

  const handleRouteSel = (newRoute: string) => {
    const planningDateStr = state?.planningDate?.toISOString()?.split("T")[0];
    if (newRoute != "") {
      const dataIndex = route;
      if (dataIndex > -1) {
        var item = state.planningData[dataIndex];
        var items = state.planningData;
        setGridTableLoader(true);
        const clone = JSON.parse(JSON.stringify(item));

        clone['history']={}
          let cus:any=RenderCustomer(item);
          clone.history["customer_status"]=cus?.props.id || '';
          clone.history["customer_msg"]=cus?.props.title || '';
          let exe_status=RenderExceeded_Status(item)  
          if(exe_status){
            if(exe_status=='DexErrors_Exceeded'){
              clone.history["exceeded_status"]='DexErrors_Exceeded'
            }
            else{
              clone.history["exceeded_status"]=exe_status
            }
          }else{
            clone.history["exceeded_status"]=null
          }

            let online = RenderOnline(item);
            if(online){
              clone.history["online"]=online?.props?.children?.props?.id ;
              clone.history["online_msg"]=online?.props?.children?.props?.title;
            }
            else{
              clone.history["online"]=null;
              clone.history["online_msg"]=null
            }
           
      let statuss= RenderStatus(item) ;
 
      if(statuss){
        clone.history["status_msg"]=statuss?.props.title || '';;
       }    
       clone.history["plant"]=props.data.selectedDeliveryPlant
        setPlanningRoute(salesOrg.toString(), item.customerNum, item.equipmentNum, newRoute, planningDateStr,clone,false,uuid).then(
          (v: string) => {
            
            if (v === "S") {
              // update successful, now update local structure w/o reloading everything
              items.splice(dataIndex, 1);
              //props.changeAll(items);
              props.changeAll(items);
              setSelectedRoutes([]);
            }
            setTimeout(()=>{setGridTableLoader(false);}, 500);
          }
        );
      } else if (selectedRoutes?.length > 0) {
        var data: any[] = [];
        selectedRoutes?.map((rowIndex: number) => {

          const clone = JSON.parse(JSON.stringify(state.planningData[rowIndex]));

          clone['history']={}
            let cus:any=RenderCustomer(clone);
            clone.history["customer_status"]=cus?.props.id || '';
            clone.history["customer_msg"]=cus?.props.title || '';
            let exe_status=RenderExceeded_Status(clone)  
            if(exe_status){
              if(exe_status=='DexErrors_Exceeded'){
                clone.history["exceeded_status"]='DexErrors_Exceeded'
              }
              else{
                clone.history["exceeded_status"]=exe_status
              }
            }else{
              clone.history["exceeded_status"]=null
            }
  
              let online = RenderOnline(clone);
              if(online){
                clone.history["online"]=online?.props?.children?.props?.id ;
                clone.history["online_msg"]=online?.props?.children?.props?.title;
              }
              else{
                clone.history["online"]=null;
                clone.history["online_msg"]=null
              }
             
        let statuss= RenderStatus(clone) ;
   
        if(statuss){
          clone.history["status_msg"]=statuss?.props.title || '';;
         }   

         clone.history["plant"]=props.data.selectedDeliveryPlant
          data.push(clone);
        });

        // console.log("🚀 ~ file: Planning.tsx ~ line 420 ~ selectedRoutes?.map ~ rowItems", data);
        setGridTableLoader(true);
        setPlanningRoute(salesOrg.toString(), "", "", newRoute, planningDateStr, data, true,uuid).then((v: string) => {
          //setShowLoader(false);
          if (v === "S") {
            const customerNum = data?.map((item: any) => item?.customerNum);
            var newItems = state.planningData?.filter((item: any) => !customerNum?.includes(item?.customerNum));
            // console.log(
            //   "🚀 ~ file: Planning.tsx ~ line 427 ~ setPlanningRoute ~ newItems",
            //   state.planningData,
            //   newItems
            // );
            //props.setRefresh(true);
            //props.changeAll(newItems);
            props.changeAll(newItems);
            setSelectedRoutes([]);
            // console.log("🚀 ~ file: Planning.tsx ~ line 423 ~ setPlanningRoute ~ v", v);
          }
          setTimeout(()=>{setGridTableLoader(false);}, 500);
        });
      }
    }
    setRoute(-1);
    setRoutePopup(false);
    setSelectedRoutes([]);
    props.routesSelected([]);
    
  };

  const handleRouteClose = () => {
    setRoute(-1);
    setRoutePopup(false);
  };

  const handleCustNumClick = (customerNum: string) => {
    window.open(`/customer/${customerNum}`, "_blank");
  };
  const handleDateChange = (newDate: any) => {
    // console.log(newDate);
    if (!isPastDate(newDate)) {
      setSelectedDate(newDate);
    } else {
      setErrorMessage({
        title: "Unable to plan for past.",
        message: "Please select a date greater or equal to TODAY.",
      });
    }
  };

  const formatDateLabel = (date: MaterialUiPickersDate, invalidLabel: string) => {
    if (isPastDate(date)) {
      return "Cannot plan for past days";
    }
    const inpDate = moment(date);
    return date && inpDate.isValid() ? inpDate.format("dddd, MMMM Do YYYY") : invalidLabel;
  };

  const isPastDate = (date: MaterialUiPickersDate): boolean => {
    const inpDate = moment(date);
    if (inpDate.isBefore(moment(new Date()).add(-1, "days"))) {
      return true;
    } else {
      return false;
    }
  };

  const canBeVisited = (visitDays: string): boolean => {
    const weekday: number = state.planningDate.getUTCDay();
    var abbrev: string = "";
    switch (weekday) {
      case 0:
        abbrev = "Su";
        break;
      case 1:
        abbrev = "M";
        break;
      case 2:
        abbrev = "Tu";
        break;
      case 3:
        abbrev = "W";
        break;
      case 4:
        abbrev = "Th";
        break;
      case 5:
        abbrev = "F";
        break;
      case 6:
        abbrev = "Sa";
        break;
    }
    return visitDays.includes(abbrev);
  };

  const onColumnOrderChange = (newColumnOrder: number[], columnIndex: number, newPosition: number) => {
    setColSequence(newColumnOrder);
  };

  const onViewColumnsChange = (changedColumn: string, action: string) => {
    var current = displayCol;
    if (action === "remove") {
      if (!current.includes(changedColumn)) {
        current.push(changedColumn);
      }
    }
    if (action === "add") {
      current = current.filter(function (ele) {
        return ele != changedColumn;
      });
    }
    setDisplayCol(current);
  };

  const isVisible = (column: string): boolean => {
    return displayColumnsLS[column] ? displayColumnsLS[column] : !displayColumnsLS[column];
  };
  const val = state && state.planningData ? state.planningData.length : 0;
  const tableHeight = 50 * val + "px"; //window.innerHeight - 450 + "px";

  /*
 window.addEventListener('resize', ()=>{
    const header =  document.querySelector('ResponsiveDrawer')
    const headerAdj = header?header.clientHeight:200;
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  */
  const dataMap = (arr: string[]): string[] => {
    return Array.from(new Set(arr));
  };
  const rowData: PlanningItem[] = state.planningData;
  let currentStatus, schedule, accessDays, salesDays, act, filterDropDowns: Data;

  const filterData = () => {
    if (rowData) {
      currentStatus = dataMap(rowData.map((s) => s?.currentStatus));
      schedule = dataMap(rowData.map((s) => s.schedulingMethod));
      accessDays = dataMap(rowData.map((a) => a.prefDays));
      salesDays = dataMap(rowData.map((s) => s.salesDays));
      act = dataMap(rowData.map((a) => a.activity));
      filterDropDowns = { currentStatus,schedule, accessDays, salesDays, act };
      filterDropDowns.currentStatus = filterDropDowns.currentStatus.map((s) => {
        const obj: { code: string; text: string } = { code: s, text: "" };
        if (s === "O") obj.text = "Overdue";
        if (s === "F") obj.text = "Future";
        if (s === "S") obj.text = "Scheduled";
        if (s === "C") obj.text = "Confirmed";
        return obj;
      });

      filterDropDowns.schedule = filterDropDowns.schedule.map((s) => {
        const obj: { code: string; text: string } = { code: s, text: "" };
        if (s === "D") obj.text = "Delay";
        if (s === "I") obj.text = "Initial";
        if (s === "C") obj.text = "Confirmed";
        return obj;
      });
      return filterDropDowns;
    }
  };
  filterData();

  function handleUndefined(params: any, filterItem: GridFilterItem): boolean {
    if (!filterItem.value) {
      filterItem.value = params.value;
      return params.value === filterItem.value;
    }
      return params.value === filterItem.value;
  }
  const handleModeChange = (e: any) => {
    const value = e.target.value;
    // console.log("value", e);
    setModeValue(value);
  };

  const updateCustomerNotes = (cn: any) => {
    const cnotes: any = [];
    cn.map((item: any) => {
      let validStartDate = item?.createdDt ? new Date(item?.createdDt.toString().split('T')[0]) : new Date();
      const validTillDate = item?.validUntilDt ? new Date(item?.validUntilDt.toString().split('T')[0]) : new Date("9999-12-31");
      const planningDate = new Date(state.planningDate.toISOString().split('T')[0]);
      const isValid = (planningDate <= validTillDate && planningDate >= validStartDate) 
      if (!item?.isDeleted && isValid) {
        const cnoteItem={...item,validUntilDt:item?.validUntilDt+'T23:59:59.000Z'}
        cnotes?.push(cnoteItem);
      }
    });
    setCustomerNotes(cnotes);
  };
  const updateHoverCustomerNotes = (cn: any) => {
    const cnotes: any = [];
    cn?.map((item: any) => {
      const date = new Date(item?.validUntilDt);
      const today = new Date();
      const isValid = date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
      if (!item?.isDeleted && isValid) {
        const cnoteItem={...item,validUntilDt:item?.validUntilDt+'T23:59:59.000Z'}
        cnotes?.push(cnoteItem);
      }
    });
    setHoverCustomerNotes(cnotes);
  };


  // Method to fetch closet date.

  function getPreviousSheduledList (dates:any,target:any){
    let prevDate='1000-01-01';
     if(dates?.length==0){
       return prevDate
     }
     for (let i = 0; i < dates?.length; i++) {
       let dateItems = dates[i];
     if(new Date(dateItems)<new Date(target)){
       if(new Date(prevDate)<new Date(dateItems)){
         prevDate=dateItems;
       }
       
     }
   }
    return  new Date(prevDate).toISOString().split('T')[0];
   }

  const checkNotesForReviewDialog =(custNotes: any)=>{
    const cnotes: any = [];
    custNotes?.map((item: any) => {
      let validStartDate = item?.createdDt ? new Date(item?.createdDt.toString().split('T')[0]) : new Date();
      const validTillDate = item?.validUntilDt ? new Date(item?.validUntilDt.toString().split('T')[0]) : new Date("9999-12-31");
      const planningDate = new Date(state.planningDate.toISOString().split('T')[0]);
      const isValid = (planningDate <= validTillDate && planningDate >= validStartDate);
      if (!item?.isDeleted && isValid) {
        const cnoteItem={...item,validUntilDt:item?.validUntilDt+'T23:59:59.000Z'}
        cnotes?.push(cnoteItem);
      }
    });
    if (cnotes?.length > 0) {
      let result:any = []
      if(custNotes.ishistory){
            result=JSON.parse(custNotes.notes)

      }
      else{
        result = cnotes.reduce((result: any, currentValue: any) => {
          (result[currentValue?.noteType] = result[currentValue?.noteType] || []).push(currentValue);
          return result;
        }, {});
      }
      return result;
    }
  }
  
  const checkForNotes = (cn: any, customerNum: any,is_history?:any): any => {
    const cnotes: any = [];
    cn?.map((item: any) => {
      let validStartDate = item?.createdDt ? new Date(item?.createdDt.toString().split('T')[0]) : new Date();
      const validTillDate = item?.validUntilDt ? new Date(item?.validUntilDt.toString().split('T')[0]) : new Date("9999-12-31");
      const planningDate = new Date(state.planningDate.toISOString().split('T')[0]);
      const isValid = (planningDate <= validTillDate && planningDate >= validStartDate);
      if (!item?.isDeleted && isValid) {
        const cnoteItem={...item,validUntilDt:item?.validUntilDt+'T23:59:59.000Z'}
        cnotes?.push(cnoteItem);
      }
    });
    if (cnotes?.length > 0) {
      let result:any = []
      if(cn.ishistory){
            result=JSON.parse(cn.notes)

      }
      else{
        result = cnotes.reduce((result: any, currentValue: any) => {
          (result[currentValue?.noteType] = result[currentValue?.noteType] || []).push(currentValue);
          return result;
        }, {});
      }
      

      // console.log("🚀 ~ file: Planning.tsx ~ line 738 ~ result ~ result", result);
      return (
        <>
          {result.CUSTOMER?.length > 0 && (
            <span>
            <IconButton
            disabled={is_history || disabled}
              size="small"
              sx={{ p: "2px" }}
              onMouseEnter={(e) => {
                updateHoverCustomerNotes(result.CUSTOMER);
                // setCustomerNotes(props.row?.customerNotes)
                setHoveredNoteType("CUSTOMER NOTES");
                handlePopoverOpen(e);
              }}
              onMouseLeave={handlePopoverClose}
              onClick={(e) => {
                // console.log(e);
                setCustomerNotesPopup(true);
                setSelectedCustomer(customerNum);
                setCustomerNotes(cnotes);
              }}
            >
              <PersonIcon fontSize="small" />
            </IconButton></span>
          )}
          {result.DRIVER?.length > 0 && (
            <span><IconButton
            disabled={is_history || disabled}
              size="small"
              sx={{ p: "2px" }}
              onMouseEnter={(e) => {
                updateHoverCustomerNotes(result.DRIVER);
                setHoveredNoteType("DRIVER NOTES");
                handlePopoverOpen(e);
              }}
              onMouseLeave={handlePopoverClose}
              onClick={(e) => {
                setCustomerNotesPopup(true);
                setSelectedCustomer(customerNum);
                setCustomerNotes(cnotes);
              }}
            >
              <LocalShippingIcon fontSize="small" />
            </IconButton></span>
          )}
          {result.DISPATCHER?.length > 0 && (
            <span><IconButton
            disabled={is_history || disabled}
              size="small"
              sx={{ p: "2px" }}
              onMouseEnter={(e) => {
                updateHoverCustomerNotes(result.DISPATCHER);
                setHoveredNoteType("DISPATCHER NOTES");
                handlePopoverOpen(e);
              }}
              onMouseLeave={handlePopoverClose}
              onClick={(e) => {
                setCustomerNotesPopup(true);
                setSelectedCustomer(customerNum);
                setCustomerNotes(cnotes);
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton></span>
          )}
          {(!result.CUSTOMER || !result.DRIVER || !result.DISPATCHER) && (
            <Tooltip title={`Add Notes`}>
              <IconButton disabled={is_history || disabled}
                size="small"
                // color="primary"
                onClick={(e) => {
                  setOpenEditWindow(true);
                  setSelectedCustomer(customerNum);
                }}
              >
                <NoteAdd fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      );
    }

    
    

    return (
      <Tooltip title={`Add Notes`}>
        <IconButton disabled={is_history || disabled}
          size="small"
          // color="primary"
          onClick={(e) => {
            setOpenEditWindow(true);
            setSelectedCustomer(customerNum);
          }}
        >
          <NoteAdd fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  };
  const setCurrent = (tableMeta: any) => {
    setSelectedOptions({
      ...selectedOptions,
      noteType: tableMeta?.noteType,
      text: tableMeta?.text,
      isDeleted: tableMeta?.isDeleted,
      isImportant: tableMeta?.isImportant,
      createdDt: tableMeta?.createdDt,
      validUntilDt: tableMeta.validUntilDt,
      createdBy: tableMeta?.createdBy,
      guid: tableMeta?.guid,
    });
    setSelectedCustomer(tableMeta?.customerNum);
  };
  const handleEdit = (tableMeta: any) => {
    // console.log("🚀 ~ file: Planning.tsx ~ line 861 ~ handleEdit ~ tableMeta", tableMeta);
    if (tableMeta) setCurrent(tableMeta);
    setOpenEditWindow(true);
  };




  const handleRouteCheckBoxSelection = (routeIndex: number, event: any) => {
    //if it is a display only role, do not do anything just return;
    if(isDisplayOnlyRole){
      event.prevenDefault();
      return;
    }
    const item = state.planningData[routeIndex];
    if (item.status != "C") {
      if (!selectedRoutes?.includes(routeIndex)) {
        const nRoutes = selectedRoutes;
        nRoutes.push(routeIndex);
        setSelectedRoutes(nRoutes);
        props.routesSelected(nRoutes);
      } else {
        const nRoutes = selectedRoutes?.filter((item: number) => item !== routeIndex);
        setSelectedRoutes(nRoutes);
        props.routesSelected(nRoutes);
      }
    }
  };

// Bulk Update 
 
// if(state.planningData.length>0){
//   state.planningData.forEach((element:any) => {
    
//     if(element.status==='S'){
//       bulkItems.set(element.customerNum,element)
//     }
//   });
  
// }

  const handleBulkCheckBoxSelection = (e:any,routeIndex: number,status:any ) => {
    const item = state.planningData[routeIndex];
   // if (item.status != "C") {
      if (!selectedRoutesCkecks?.includes(routeIndex)) {
        const nRoutes = selectedRoutesCkecks;
        nRoutes.push(routeIndex);
        setSelectedRoutesCkecks(nRoutes);
      } else {
        const nRoutes = selectedRoutesCkecks?.filter((item: number) => item !== routeIndex);
        setSelectedRoutesCkecks(nRoutes);
      }
    //}


     let newObj = bulkItems.filter((cus:any) => cus.customerNum !== item.customerNum);
     if(e.target.checked){
       newObj.push(item)
       setbulkItems(newObj);
       if(status === "P"){
        scheduleList.push(item)
       } else if (status === "S") {
        unscheduleList.push(item)
       }
   
    //  // bulkItems.set(item.customerNum,item)
    setbulkshedule(true);
     }else{
      setbulkItems(newObj);
      if(bulkItems.length==1){
        setbulkItems([]);
         setbulkshedule(false);

       }
       
       if(status === "P"){
        const index = scheduleList.findIndex((element:any) =>{
          return element.customerNum === item.customerNum;
        });
        scheduleList.pop(index)
       } else if (status === "S") {
        const index = unscheduleList.findIndex((element:any) =>{
          return element.customerNum === item.customerNum;
        });
        unscheduleList.pop(index)
       }
    //   //bulkItems.delete(item.customerNum)
     }
    // if(bulkItems.length==0){
      
    //   if(item.status=='S'){
    //     setbulkshedule(true);
    //     setUnbulkshedule(false)
    //   }
    //   else{
    //     setbulkshedule(false);
    //     setUnbulkshedule(true)
    //   }


    // }
    
   
  };

  

  const checkForNonMatNMult=()=>{
    const isMultCustomer : Boolean = selectedRoutes.some(num => 
        props.data.planningData[num].activity==="MULT"
    )
    if (isMultCustomer) {
      const alert={
        alertTitle:'Change Route Alert',
        alertMessage:'Please uncheck the customers with activity MULT and update sap with one activity correctly.',
        isAlertOpen:true,
        alertProceedButton:false,
        alertDenyButton:false,
        alertDisable:false,
      };
      return setCommonAlert(alert)
    }
    return setRoutePopup(true)
  }
  const handleBulkSchedule=()=>{
    const isMultCustomer=bulkItems.some(customer=>customer.activity==="MULT");
    if (isMultCustomer) {
      const alert={
        alertTitle:'Schedule Alert',
        alertMessage:'Please uncheck the customers with activity MULT and update sap with one activity correctly.',
        isAlertOpen:true,
        alertProceedButton:false,
        alertDenyButton:false,
        alertDisable:false,
      };
      return setCommonAlert(alert)
    }
    let newDate = new Date(state.planningDate);
    let obj:any=[]
    let newStatus='S'
    bulkItems.forEach(element => {

    //for (let [key, element] of bulkItems) {
        if(element.status==='P'){
          element['history']={}
          let cus:any=RenderCustomer(element);
          element.history["customer_status"]=cus?.props.id || '';
          element.history["customer_msg"]=cus?.props.title || '';
          let exe_status=RenderExceeded_Status(element)  
          if(exe_status){
            if(exe_status=='DexErrors_Exceeded'){
              element.history["exceeded_status"]='DexErrors_Exceeded'
            }
            else{
              element.history["exceeded_status"]=exe_status
            }
          }else{
            element.history["exceeded_status"]=null
          }

            let online = RenderOnline(element);
            if(online){
              element.history["online"]=online?.props?.children?.props?.id ;
              element.history["online_msg"]=online?.props?.children?.props?.title;
            }
            else{
              element.history["online"]=null;
              element.history["online_msg"]=null
            }
           
      let statuss= RenderStatus(element) ;
 
      if(statuss){
         element.history["status_msg"]=statuss?.props.title || '';
       }    

        //In case if there is a route change suggested by supervisor, look for it and make the change in review				
        if( props.data.selectedRoute != element.routePlan && element?.txVisitPlanningReview && element?.txVisitPlanningReview.length){
            if(element?.txVisitPlanningReview?.routePlan != element.routePlan){
              element.routeAct = element?.txVisitPlanningReview[0]?.routePlan;
            }
        }
          obj.push(element)
        }
        element["nfk"] = !element.online ? 2 :(element.online && element.isFKMissed) ? 1 : 0;
      })
      if(obj.length>0){
        setGridTableLoader(true);
        setbulkSchedule(state.selectedRoute,salesOrg.toString(), newStatus, newDate,obj,uuid).then((v: string) => {
          if (v === "S") {
            /**
             * Start setting schedule status to items
             */
            const stateObjectItems = state.planningData;
      
            bulkItems.map((item: any) => {
                item.status = newStatus;
                item.activity = item.equipmentStatus;
                item.nextDeliveryAct = newDate?.toISOString()?.split("T")[0];
                if (item.sheduled.length > 0) {
                    item.sheduled.push({
                        customer_num: item.customerNum,
                        visit_dt_plan: newDate?.toISOString()?.split("T")[0],
                        route_act: item.routeAct
                    });

                    const minDate = new Date(
                        Math.min(
                            ...item.sheduled.map((element: any) => {
                                return new Date(element.visit_dt_plan);
                            }),
                        ),
                    );
                    item.sheduledDate = minDate.toISOString().split("T")[0];
                } else {
                    item.sheduledDate = newDate.toISOString().split("T")[0];
                    item.nextDeliveryAct = newDate.toISOString().split("T")[0];
                }
                //
                //Finding & replacing the state object
                const index = stateObjectItems.findIndex((obj: any) => obj.customerNum === item.customerNum);
                stateObjectItems[index] = item;
            });

            props.changeAll(stateObjectItems);
            setSelectedRoutesCkecks([]);
            setbulkItems([])
            setbulkshedule(false);
           // setUnbulkshedule(false)
            // update successful, now update local structure w/o reloading everything
            //props.reloadAll()
          }
          setGridTableLoader(false);
        });
      }
  }

const handleBulkUnschedule = async() => {
    let newDate = new Date(state.planningDate);
    let obj: any = []
    let newStatus = 'P'
    let BatchUnchedule: any = [];
    
    bulkItems.forEach(element => {
      // for (let [key, element] of bulkItems) {
      if (element.status === 'S') {
        if (element.routeAct !== element.routePlan) {
          if (adminSettingEnable == 1) {
            BatchUnchedule.push(element)
          } else {
            obj.push(element)
          }
        } else {
          obj.push(element)
        }
      }
    });
    //
  
    const stateObjectItems: any = _.cloneDeep(state.planningData);
    if (obj.length > 0) {
        setGridTableLoader(true);
        const unscheduleResponse: any= await setbulkUnSchedule(state.selectedSalesOffice, state.selectedRoute, salesOrg.toString(), newStatus, newDate, obj, uuid);
        if(unscheduleResponse === "S"){
          /**
            * Start setting schedule status
            */
            obj.map((item: any) => {
                item.status = newStatus;
                item.activity = item.equipmentStatus;
                item.nextDeliveryAct = newDate?.toISOString()?.split("T")[0];
                let dates=newDate.toISOString().split("T")[0];
                //
                if(item.sheduled.length>0){
                  item.sheduled.splice(item.sheduled.findIndex((a:any) => a.visit_dt_plan === dates) , 1)
                  const minDate = new Date(
                    Math.min(
                      ...item.sheduled.map((element:any )=> {
                        return new Date(element.visit_dt_plan);
                      }),
                    ),
                  );
                  

                  if(item.sheduled.length>0){
                    item.sheduledDate=minDate.toISOString().split("T")[0];
                    item.nextDeliveryAct = minDate.toISOString().split("T")[0];
                    
                  }else{
                    item.sheduledDate= item.nextDeliveryPlan;
                    item.nextDeliveryAct = item.nextDeliveryPlan;
                  }
                }else{
                  item.sheduledDate= item.nextDeliveryPlan;
                  item.nextDeliveryAct = item.nextDeliveryPlan; //newDate.toISOString().split("T")[0];
                }
                item.ftc=false;
                //Finding & replacing the state object
                const index = stateObjectItems.findIndex((obj: any) => obj.customerNum === item.customerNum);
                stateObjectItems[index] = item;
            });
        }
    }

    if(BatchUnchedule.length > 0){
        setPlanningDataStore(stateObjectItems);
        routesDifferMaster(BatchUnchedule);
    }else{
      props.changeAll(stateObjectItems);
      setSelectedRoutesCkecks([]);
      setbulkItems([]);
      setbulkshedule(false);
      setGridTableLoader(false);
      // setUnbulkshedule(false)
      // update successful, now update local structure w/o reloading everything
      //props.reloadAll()
    }
  }



  const routesDifferMaster=(rotesArr:any)=>{
    setRouteBatchItem(rotesArr);
    setConfirmBatchRouteReset(true)
  }

  let getSessionCustomerList=(cus:any)=>{
      let arry:any=[...props.SessionCustomerList]
      if(arry.length>0){
        return arry.includes(cus)
      }
      else{
        return false
      }

  }

  /*** 
   * Runder  Cusromer 
   */
  let RenderCustomer=(item:any)=>{
    const PLAN_DT_STR = item?.nextDeliveryAct ? 
    new Date(Date.parse(`${item?.nextDeliveryAct}`))?.toISOString()?.split("T")[0] : '';
    const planningDate = state?.planningDate?.toISOString()?.split("T")[0];
    const expected_fill_dates = item.expectedFills
      .map((ef: any) => new Date(Date.parse(`${ef.fillDt}`))?.toISOString()?.split("T")[0])
      .filter((dtstr: any) => dtstr !== planningDate);
    var isSuspended = false;
    if (item.suspended) {
      const suspVal = Date.parse(item.suspended);
      const susFromDt = new Date(item.suspendedFromDt);
      const today = new Date();
      /**to calculate number of days difference between today to suspended from date */
      const timeDiff =  new Date(susFromDt).getTime() - new Date().getTime();
      const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
      const futureSusWrnDay=parseInt(susFutDt);
      if (suspVal > state.planningDate.valueOf()&&diffDays <= futureSusWrnDay) {
        isSuspended = true;
      }
    }

    var isVisitCancelled = false;
    let loadDates = '';
    let msg = '';
    if(item.cancelVisitDates && item?.cancelVisitDates[0]?.load_date!=null){
      isVisitCancelled = true;
      loadDates = item?.cancelVisitDates[0]?.load_date;
    }

    if(loadDates.length > 10){
      msg = "Visit cancelled for dates: "
    }
    else {
      msg = "Visit cancelled for date: "
    }
    
    

    
    if (isSuspended) {
      
      return (
        <Tooltip title={`suspended until from ${item.suspendedFromDt} to ${item.suspendedToDt}`} id={"suspende"}>
          <Chip
            label={item.customerNum}
            icon={<HighlightOffIcon  style={{color:'red'}}/>}
            style={{ padding: "0px" }}
            variant="outlined"
            onClick={() => handleCustNumClick(item.customerNum)}
          />
        </Tooltip>
      );
    }

    else if (isVisitCancelled) {
      let isVisitCancelUpdated=false;
      let scheduledMessage="";
      let confirmedMessage="";
      let latestMessage="";
      if (item.pastScheduleCustomers.length>0) {
        const pastScheduleCustomers=item.pastScheduleCustomers;
        const latestPastScheduledDate=pastScheduleCustomers.map((value:any)=>new Date(Date.parse(`${value?.visit_dt_plan}`))?.toISOString()?.split("T")[0]).sort().slice(-1);
        const latestCancelVisitDate=item?.cancelVisitDates[0]?.load_date.split(",").sort().slice(-1);
        if (new Date(latestPastScheduledDate)>=new Date(latestCancelVisitDate)) {
          isVisitCancelUpdated=true;
          const confirmedDates=pastScheduleCustomers.filter((item:any)=>item.status!=="S").map((value:any)=>new Date(Date.parse(`${value?.visit_dt_plan}`))?.toISOString()?.split("T")[0]).sort();
          if (confirmedDates.length>0) {
            confirmedMessage="Expected to visit on "+confirmedDates.join(",  ");
          }
          const scheduleDates=pastScheduleCustomers.filter((item:any)=>item.status!=="C").map((value:any)=>new Date(Date.parse(`${value?.visit_dt_plan}`))?.toISOString()?.split("T")[0]).sort();
          if (scheduleDates.length>0) {
            scheduledMessage="Scheduled on "+scheduleDates.join(",  ");
          }
          latestMessage=scheduledMessage.length>0?(confirmedMessage.length>0?confirmedMessage+", "+scheduledMessage+" and ":scheduledMessage+" and "):confirmedMessage+" and ";
        }else{
          isVisitCancelUpdated=false;
        }
      }

      return (
        <Tooltip title={latestMessage + msg + loadDates} id={"Visit_cancelled"}>
          <Chip
            label={item.customerNum}
            icon={isVisitCancelUpdated?<LocalShippingIcon />:<NoTransferIcon />}
            style={{ padding: "0px" }}
            color="primary"
            variant="filled"
            onClick={() => handleCustNumClick(item.customerNum)}
          />
        </Tooltip>
      );
    }
    
    
    else if (expected_fill_dates.length > 0) {

      return (
        <Tooltip title={"Expected to visit " + expected_fill_dates.sort().join(",  ")}  id={"Expected_to_visit"}>
          <Chip
            label={item.customerNum}
            color="primary"
            icon={<LocalShippingIcon />}
            variant="filled"
            onClick={() => handleCustNumClick(item.customerNum)}
          />
        </Tooltip>
      );
    }

    if(item.ishistory){
      if(item.customer_status==0){
        return (
          <Tooltip title={item.customer_msg} id={"Visit_cancelled"}>
            <Chip
              label={item.customerNum}
              color="primary"
              icon={<LocalShippingIcon />}
              variant="filled"
             
            />
          </Tooltip>
        );
      }else if(item.customer_status==1){

        return (
          <Tooltip title={item.customer_msg} id={"Visit_cancelled"}>
          <Chip
            label={item.customerNum}
            icon={<LocalShippingIcon />} //:<NoTransferIcon /> isVisitCancelUpdated?
            style={{ padding: "0px" }}
            color="primary"
            variant="filled"
            
          />
        </Tooltip>
        )
                      }
                      else if(item.customer_status==2){
                        return (
                          <Tooltip title={item.customer_msg} id={"Overdue"}>
                            <Chip
                              label={item.customerNum}
                              icon={<HighlightOffIcon  style={{color:'red'}}/>}
                              style={{ padding: "0px" }}
                              variant="outlined"
                           
                            />
                          </Tooltip>
                        );
                                      }
    }

    else {
      return (
        <Tooltip title={`Overdue`} id={"Overdue"}> 
        <Chip
          label={item.customerNum}
          variant="outlined"
          onClick={() => handleCustNumClick(item.customerNum)}
        />
        </Tooltip>
      );
    }
  }
  /*** 
   *  End Runder  Cusromer 
   */

/**
 * Exceeded Status
 */
let RenderExceeded_Status=(elemets:any)=>{

  var output: any = "Online";

  if (!elemets.online) return;

  if (elemets.dexErrors) {
    output = "DexErrors";
  }
  if (elemets.exceededStatus) {
    output = "Exceeded";
  }
  if (elemets.dexErrors && elemets.exceededStatus) {
    output = "DexErrors & Exceeded"
  }

  if(elemets.ishistory){
     enum ExceededStatus{
      Online = 0,
      DexErrors=1,
      Exceeded=2,
      DexErrors_Exceeded=3
  
    };

    if(elemets.exceeded_status){
      output=ExceededStatus[elemets.exceeded_status]
    }
    

  }
 

  return output

}

/**
 * Online  
 */

let RenderOnline=(item:any)=>{
  let color: any = "default";
  let tooltip = item.online;
  
  if (item.online && item.online != "") {
    if (item.online && item.dexErrors) {
      color = "primary";
    }

    if (item.online && item.exceededStatus) {
      color = "default";
      tooltip = item.online + " | " + item.exceededDays + "Days";
    }
    if (item.online && item.dexErrors && item.exceededStatus) {
      color = "statusOrange";
      tooltip = item.online + " | " + item.exceededDays + "Days";
    }
    if (item.online && item.dexErrors == false && item.exceededStatus == false) {
      color = "statusGreen";
      if(item.isFKMissed){
        color = "statusPurple";
      }
    }
    
    if (item.online && item.telemeterReplaced) {
      color= "statusYellow";
      tooltip = item.exceededDays;
    }

    if(item.ishistory){
    enum OnlineStatus {
        primary=0, // DexErrors
        default=1, // Exceeded
        statusOrange=2 , //DexErrors And exceeded
        statusGreen=3, //Online
        statusYellow=4, //Telemeter Replaced
        statusPurple=5, //FillKey Missed Processed
      }
      color=OnlineStatus[item.online]
      tooltip=item.online_msg;

    }

    return (
      <>
        <Tooltip title={tooltip} id={color}>
          <SettingsInputAntennaIcon color={color} />
        </Tooltip>
      </>
    );
  }


 }	


 /***
  * Status 
  */

 let RenderStatus=(item:any)=>{ 
  const dataIndex = parseInt(`${item.id}`);
  const index = state.planningData.findIndex((x: any) => x.customerNum === item.customerNum);
   const planningDate = state?.planningDate?.toISOString()?.split("T")[0];
   let color: PropTypes.Color = "inherit";
   let variant: "text" | "outlined" | "contained" | undefined = "outlined";
   let icon = <NotificationImportantIcon />;
   var toolt = "Overdue";
   let btnStyle:any={ padding: "2px"}; //   let style={ padding: "2px", backgroundColor: "green" };
   
   if (item) {
      const nextDelAct = item?.nextDeliveryAct ? 
      new Date(Date.parse(item?.nextDeliveryAct))?.toISOString()?.split("T")[0] : '';
      //Adding for overdue if difference between last delivery date and planning date is > 60 and without any prior schedules
      let scheduledDates = [];
      for (let i=0; i<item?.sheduled?.length; i++){
        scheduledDates?.push(item.sheduled[i].visit_dt_plan);
      }
      const closestDate = getPreviousSheduledList(scheduledDates,planningDate);
      const currentPlDate:any = new Date(planningDate);
      let clstDate:any = new Date(closestDate);
      let clstDateDiff = Math.ceil(Math.abs(clstDate - currentPlDate)/(1000 * 60 * 60 * 24));
      const lastDelDate:any = new Date(item?.lastDelivery);
      let lastDeliverydiff = Math.ceil(Math.abs(lastDelDate - currentPlDate)/(1000 * 60 * 60 * 24));
     // let  isOverdue = false;

      if (nextDelAct > planningDate && item.dri >= 0) {
       // in the future
       icon = <AccessTimeIcon color={item.loading ? "disabled" : "inherit"} />;
       toolt = `Future (click to pull forward)`;
     }


      if(lastDeliverydiff > 60  &&  clstDateDiff > 60){
       icon = <NotificationImportantIcon />;
       toolt = 'Overdue';
       
      }

      if(item?.sheduled?.length == 0 && new Date(item?.nextDeliveryAct) > new Date(planningDate) && item?.dri < 0) {
       icon = <NotificationImportantIcon />;
       toolt = 'Overdue';
      
      }

      if(item.sheduled.length > 0 &&item.sheduled.some((i:any) => i.visit_dt_plan.includes(item.nextDeliveryAct))&& new Date(item.nextDeliveryAct) > new Date()) {
       toolt = "Scheduled for "+item.nextDeliveryAct;
       icon = <LocalShippingIcon />;

      }
      

     if (item.nextDeliveryAct <= planningDate) {
       // Needs to roll
       color = "primary";
       if(item.status === 'P'){
         toolt = "Overdue";
         if(item.sheduled.length > 0 &&item.sheduled.some((i:any) => i.visit_dt_plan.includes(item.nextDeliveryAct))&& new Date(item.nextDeliveryAct) > new Date()) {
           toolt = "Scheduled for "+item.nextDeliveryAct;
         }
       }
       if(item.status === 'S'){
         toolt = item.nextDeliveryAct;
       }
     }

     

     if (item.nextDeliveryAct === planningDate) {
       // current day
       toolt = "Proposed for " + item.sheduledDate.toString().split("T")[0]//item.nextDeliveryAct;
       icon = <AccessTimeIcon color={item.loading ? "disabled" : "inherit"} />;
       variant = "contained";
   
       if (item.status === "S") {
         toolt = "Scheduled for selected planning date " + item.nextDeliveryAct; 
       }
     }

      // status button highlighting with red color when proposed del date and planning date are same .
      if (item?.nextDeliveryPlan && item?.nextDeliveryPlan?.split("T")[0] === planningDate && !(item?.status=='S' || item?.status=='C')) {
          variant = "contained";
          btnStyle={ padding: "2px", backgroundColor: "orange" };
      }


     if (item.status === "S") {
       icon = <LocalShippingIcon />;
       toolt = `Scheduled for  ${item.sheduledDate.toString().split("T")[0]} `; //${item.nextDeliveryAct}
     
     }

     if (item.status === "C") {
       icon = <DoneOutlineIcon />;
       toolt = `Confirmed for ${item.sheduledDate.toString().split("T")[0]}`; //${item.nextDeliveryAct}
     }


    if (item.status === "S" &&  getSessionCustomerList(item.customerNum)) {
     icon =  <> <GroupIcon /> <LocalShippingIcon /></>;
     toolt = `Scheduled for  ${item.sheduledDate.toString().split("T")[0]} `; //${item.nextDeliveryAct}
   
   }
   //Additinal change to support review functionality when review comment has a route change suggestion
   if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && item?.sheduled?.length > 0 && item.routePlan !== item?.txVisitPlanningReview[0]?.routePlan){
      const foundItem:any = item?.sheduled.find((ele: any)=> ele.visit_dt_plan == planningDate);
      if(foundItem && foundItem?.status === "S" && item.status=="P"){
        icon = <LocalShippingIcon />;
        variant = "outlined";
        toolt = `Scheduled for route ${foundItem?.route_act}`;
      }else if(foundItem && foundItem?.status === "C" && item.status=="P"){
        icon = <DoneOutlineIcon />;
        variant = "outlined";
        toolt = `Confirmed for route ${foundItem?.route_act}`;
      }
   }
 
   if(item.ishistory){
     variant = "contained";
     icon = <DoneOutlineIcon />;
     toolt = item.status_msg
   }



     return (
       <span title={toolt} >
       <CircularLoadButton
         id={dataIndex}
         settingsKey="VS_PLN"
         style={btnStyle}
         title=""
         icon={icon}
         variant={variant}
         tooltip={toolt}
         status={savingActive&&savingCustNum==item.customerNum||item.loading ? LoadingStatus.Loading : LoadingStatus.Initial}
         disabled={(statusOflist == 1 && item.status != "C" ? true : false) || disabled || (isDisplayOnlyRole && item.status == "P"  && !item?.review)}
         loadFn={(e) => handleStatusClick(item, dataIndex, e)}
       />
       
       {item.status != "C" && statusOflist == 0  ?


       <Checkbox  
       
                          disabled={disabled}
                           checked={selectedRoutesCkecks.includes(dataIndex)}
                           onChange={(e) => handleBulkCheckBoxSelection(e,dataIndex,item.status )}
       
       /> 
       
       :
       (item.status === "C" && statusOflist == 1 || item.ishistory ?<>
       <Checkbox  
       
       
       checked={selectedRoutesCkecks.includes(dataIndex)}
       onChange={(e) => handleBulkCheckBoxSelection(e,dataIndex,item.status )}

       /> 
       </>:"")
     }
   </span>
     );
   }
 }
 
 const isFutureDate: boolean = (new Date(state?.planningDate)>new Date(new Date().toISOString().split('T')[0]));

  const handleOverdueClick = () => {
    setIsOverdueMachine(true);
  }

  const printReviewTitleStatus = (rowItem: any, txVisitPlanningReviewItem: any)=>{
    //Generating title for history data
    if(rowItem.ishistory){
      let scheduleButtonContent: any=<></>;
      if(txVisitPlanningReviewItem?.schedulePlan == "S"){
          scheduleButtonContent = (<Stack direction="row" spacing={2}>
              <Button  variant={"contained"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button></Stack>)
      }else{
        scheduleButtonContent = (<Stack direction="row" spacing={2}>
            <Button  variant={"outlined"} style={{ padding: "2px"}}>
              <LocalShippingIcon/>
            </Button></Stack>)
      }
      return (
        <span style={{ overflow: "auto"}}>
          <div>{scheduleButtonContent}</div>
          <p style={{ marginLeft:"5px"}}>{txVisitPlanningReviewItem?.activityPlan}</p>
          <p style={{ marginLeft:"10px"}}>{txVisitPlanningReviewItem?.routePlan}</p>
          <div><Checkbox sx={{color: "white"}}  checked={txVisitPlanningReviewItem?.ftcPlan}/></div>
        </span>
      )
    }
    
    //if not history data
    if(rowItem?.routeAct == txVisitPlanningReviewItem?.routePlan && rowItem?.status == txVisitPlanningReviewItem?.schedulePlan
              && rowItem?.activity == txVisitPlanningReviewItem?.activityPlan && rowItem?.ftc == txVisitPlanningReviewItem?.ftcPlan
    ){
      let scheduleButtonContent: any=<></>;
      if(rowItem?.status == "S"){
        scheduleButtonContent = (<Button variant={"contained"} style={{ padding: "2px"}}>
          <LocalShippingIcon/>
        </Button>)
      }else{
        scheduleButtonContent =(<Button variant={"outlined"} style={{ padding: "2px"}}>
          <LocalShippingIcon/>
        </Button>)
      }
      return (
        <div>
          <div>{scheduleButtonContent}</div>
          <p style={{ marginLeft:"5px"}}>{rowItem?.activity}</p>
          <p style={{ marginLeft:"5px"}}>{rowItem?.routeAct}</p>
          <div style={{ marginLeft:"5px"}}><Checkbox sx={{color: "white"}}  checked={rowItem?.ftc} /></div>
        </div>
      )
    }else{
      let scheduleButtonContent: any=<></>;
      let activityContent: string="";
      let routeContent: string="";
      let ftcContent: any=<></>;
      if(rowItem?.status != 'C' && rowItem?.status != txVisitPlanningReviewItem?.schedulePlan){
          if(rowItem?.status == "S"){
          scheduleButtonContent = (<Stack direction="row" spacing={2}>
              <Button variant={"contained"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button>
              <p style={{marginTop:"5px"}}>{">>"}</p>
              <Button  variant={"outlined"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button>
          </Stack>)
        }else{
          scheduleButtonContent = (<Stack direction="row" spacing={2}>
              <Button  variant={"outlined"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button>
              <p style={{marginTop:"5px"}}>{">>"}</p>
              <Button variant={"contained"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button>
          </Stack>)
        }
      }else{
        if(rowItem?.status == "S"){
          scheduleButtonContent = (<Stack direction="row" spacing={2}>
              <Button  variant={"contained"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button></Stack>)
        }else{
          scheduleButtonContent = (<Stack direction="row" spacing={2}>
              <Button  variant={"outlined"} style={{ padding: "2px"}}>
                <LocalShippingIcon/>
              </Button></Stack>)
        }

      }
      
      if(rowItem?.activity != txVisitPlanningReviewItem?.activityPlan){
        activityContent = `${rowItem?.activity} >> ${txVisitPlanningReviewItem?.activityPlan}`;
      }else{
        activityContent = `${rowItem?.activity}`
      }

      if(rowItem?.routeAct != txVisitPlanningReviewItem?.routePlan){
        routeContent = `${rowItem?.routeAct} >> ${txVisitPlanningReviewItem?.routePlan}`;
      }else{
        routeContent = `${rowItem?.routeAct}`
      }

      if(rowItem?.ftc != txVisitPlanningReviewItem?.ftcPlan){
        ftcContent = (
          <Stack direction="row" spacing={2}><Checkbox style={{ padding: "2px"}} checked={rowItem?.ftc}/>
          <p style={{marginTop:"5px"}}>{">>"}</p>
          <Checkbox style={{ padding: "2px"}} sx={{color: "white"}}  checked={txVisitPlanningReviewItem?.ftcPlan}/></Stack>
        );
      }else{
        ftcContent = <Checkbox sx={{color: "white"}} checked={rowItem?.ftc}/>;
      }


      return (
        <span style={{ overflow: "auto"}}>
          <div>{scheduleButtonContent}</div>
          <p style={{ marginLeft:"5px"}}>{activityContent}</p>
          <p style={{ marginLeft:"5px"}}>{routeContent}</p>
          <div>{ftcContent}</div>
        </span>
      )
    }
  }

  const printReviewTitleComments = (commentsObject: any) =>{
    return (<span style={{display: "inline-block", overflow: "auto"}}>
              {commentsObject.length && commentsObject.map((ele: any)=>{
                if(ele?.comments){
                  return(
                  <div id="chatBoxPlanner">
                  {ele?.role_type?.toLowerCase() === 'planner' ? (<><p style={{display: "inline-block", fontSize:"17px", fontWeight:"bold"}}>{`${ele?.user_name?.split("@")[0]}(P)`}</p> 
                      <p style={{display: "inline-block", marginLeft: "10px",  fontSize:"13px"}}>{`${ele?.timestamp.split("T")[0]} : ${ele?.timestamp.split("T")[1].substr(0, 8)} (UTC)`}</p>
                      <p style={{ marginTop: "-15px", overflowWrap: "break-word"}}>{ele?.comments}</p>
                      </>):
                  ((<><p style={{display: "inline-block", fontSize:"17px", fontWeight:"bold"}}>{`${ele?.user_name?.split("@")[0]}(S)`}</p>
                      <p style={{display: "inline-block", marginLeft: "10px",  fontSize:"13px",}}>{`${ele?.timestamp.split("T")[0]} : ${ele?.timestamp.split("T")[1].substr(0, 8)} (UTC)`}</p>
                      <p style={{marginTop: "-15px", overflowWrap: "break-word"}}>{ele?.comments}</p>
                    </>))}
                  </div>)
                }else{
                  <></>
                }
              
              })}
            </span>)
  }
 
  const columns: TableAbstractionColumn[] = [
    {
      label: "Sort",
      name: "sort",
      options: {
        sort:true,
        filter: false,
        searchable: false,
        renderCell: (props) => {
          return <div />;
        },
      },
    },
    {
      label: "Notes",
      name: "customerNotes",
      valueGetter: (props) => {
        if (props.row.customerNotes && props.row.customerNotes.length>0 ) {
            return props.row.customerNotes?.map((note:any) => `"${note.text.replace(/"/g, '\\"')}"\n`).join('');
        } else {
            return '';
        }
    },    
      options: {
        filter: false,
        searchable: false,
        renderCell: (props: any) => {
          const item = props.row;
          const notesObject = notes ? notes[props.row?.customerNum] : [];
          return checkForNotes(notesObject, props.row?.customerNum, item.ishistory);
        },
      },
    },
    {
      label: "Customer #",
      name: "customerNum",
      options: {
        filter: true,
        searchable: true,
        display: isVisible("customerNum"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
          return RenderCustomer(item)
          }
        },
      },
    },

    {
      label: "Status",
      name: "currentStatus",
      options: {
        sort: true,
        filter: true,
        searchable: false,
        display: false,
        // renderCell: (props) => {
        //   const dataIndex = parseInt(`${props.id}`);
        //   const item = props.row;
        //   const planningDateStr = state?.planningDate?.toISOString()?.split("T")[0];
        //   if (item) {
        //     if (item.routeAct) {
        //       return (
        //         <>
        //           <Link component="button" onClick={() => handleRouteClick(dataIndex,item.customerNum,salesOrg,planningDateStr)}>
        //             {item.routeAct}
        //           </Link>
        //           <Checkbox
        //             checked={selectedRoutes.includes(dataIndex)}
        //             onChange={() => handleRouteCheckBoxSelection(dataIndex)}
        //             // inputProps={{ 'aria-label': 'controlled' }}
        //           />
        //         </>
        //       );
        //     }
        //   }
        // },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return handleUndefined(params, filterItem);
              };
            },
            label: "equals",
            value: "status_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.currentStatus.map((v: any) => (
                  <option value={v.code}>
                    {v.code} - {v.text}{" "}
                  </option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if (!filterItem.value) filterItem.value = params.value;
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "status_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.currentStatus.map((v: any) => (
                  <option value={v.code}>
                    {v.code} - {v.text}
                  </option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    },

    {
      label: "Status",
      name: "status",
      valueGetter: (props) => {
        if(props?.row?.status == "S" || props?.row?.status == "C")
        return `A_${props?.row?.status}`;
      },
      options: {
        searchable: false,
        filter: false,
        display: isVisible("status"),
        renderCell: (props) => {
          const item: any = props.row;
          return RenderStatus(item);
        },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return handleUndefined(params, filterItem);
              };
            },
            label: "equals",
            value: "status_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.currentStatus.map((v: any) => (
                  <option value={v.code}>
                    {v.code} - {v.text}{" "}
                  </option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if (!filterItem.value) filterItem.value = params.value;
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "status_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.currentStatus.map((v: any) => (
                  <option value={v.code}>
                    {v.code} - {v.text}
                  </option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    },
    {
      label: "Review",
      name: "review",
      hideable: isReviewFeatureEnabled ? true : false,
      options: {
        filter: isReviewFeatureEnabled || false,
        searchable: isReviewFeatureEnabled || false,
        display: isReviewFeatureEnabled || false,
        hint:"Review Comments",
        renderCell: (props) => {
          const rowItem:any = props.row;
          const txVisitPlanningReviewItem:any = rowItem?.txVisitPlanningReview[0];
          const dataIndex = parseInt(`${props.id}`);
          //checking if planner has made any changes for reviewer's suggestion.
          let checkBoxColor: any = "red";
          const comments = JSON.parse(txVisitPlanningReviewItem?.reviewComments || `[]`);
          if(rowItem?.txVisitPlanningReview.length){
            if(rowItem?.routeAct == txVisitPlanningReviewItem?.routePlan
              && rowItem?.activity == txVisitPlanningReviewItem?.activityPlan && rowItem?.ftc == txVisitPlanningReviewItem?.ftcPlan
            ){
               if(rowItem?.routeAct != rowItem?.routePlan && (rowItem?.status == txVisitPlanningReviewItem?.schedulePlan || rowItem?.status == "C" && txVisitPlanningReviewItem?.schedulePlan =="S")){
                  checkBoxColor = "green";
               }else if(rowItem?.status == txVisitPlanningReviewItem?.schedulePlan || rowItem?.status == "C" && txVisitPlanningReviewItem?.schedulePlan =="S"){
                checkBoxColor = "green";
               }
            }else if(comments.length && comments[0]?.role_type === 'planner'){
              checkBoxColor = "purple";
            }
          }
           return(
            <Tooltip title={
                (rowItem?.txVisitPlanningReview.length) ? <ul className={classes.ulNoBullets}>
                  <li>{printReviewTitleStatus(rowItem, txVisitPlanningReviewItem)}</li>
                  <li>{printReviewTitleComments(comments)}</li>
                </ul>:
                "review comments"
              }>
              <span>
              <Checkbox disabled={disabled} checked={ rowItem?.review } sx={{'&.Mui-checked': {color: checkBoxColor}}}
                  onClick={(event: any) => {
                    const notesObject = notes ? notes[rowItem?.customerNum] : [];
                    const item: any = {
                      dataIndex,
                      customerNum: rowItem?.customerNum ,
                      initialStatus: rowItem?.review ? txVisitPlanningReviewItem?.schedulePlan : rowItem?.status,
                      initialActivity: rowItem?.review ? txVisitPlanningReviewItem?.activityPlan : rowItem?.activity,
                      initialFTC: rowItem?.review ? txVisitPlanningReviewItem?.ftcPlan : rowItem?.ftc,
                      initialRoute:rowItem?.routeAct,
                      schedulePlan:rowItem?.review ? txVisitPlanningReviewItem?.schedulePlan : rowItem?.status, 
                      activityPlan: rowItem?.review ? txVisitPlanningReviewItem?.activityPlan : rowItem?.activity,  
                      routePlan: rowItem?.review ? txVisitPlanningReviewItem?.routePlan : state.selectedRoute,
                      ftcPlan: rowItem?.review ? txVisitPlanningReviewItem?.ftcPlan : rowItem?.ftc,
                      deliveryPlant: rowItem?.review ? txVisitPlanningReviewItem?.deliveryPlant : state.selectedDeliveryPlant,
                      loadDate: state?.planningDate?.toISOString()?.split("T")[0],
                      comments: (rowItem?.review && txVisitPlanningReviewItem) ? JSON.parse(txVisitPlanningReviewItem?.reviewComments) : [],
                      review: rowItem?.review,
                      masterRoute: rowItem?.routePlan,
                      notesContent: checkNotesForReviewDialog(notesObject)
                    }
                    setInitailStateOfReviewObj(item);
                    setReviewDialogData(item);
                    setReviewDialog(true);
                    event.preventDefault();
                  }}
              />
              </span>
              </Tooltip>
            )
        },
      },
    },
    {
      label: "Season",
      name: "season",
      options: {
        searchable: false,
        filter: false,
        hint: (
            <ul className={classes.tooltip}>
              <li style={{ display: "flex"}}> 
                <span style={{fontWeight: "bold", fontSize:"16px", color:"greenyellow", marginTop:"-5px", marginRight:"5px"}}>S</span> Season active & Seasonality Factor applied
              </li>
              <li style={{ display: "flex" }}>
              <span style={{fontWeight: "bold", fontSize:"16px", color:"#d62929", marginTop:"-5px", marginRight:"5px"}}>S</span> Season active & received enough settlements during season to predict with
              </li>
              <li style={{ display: "flex" }}>
              <span style={{fontWeight: "bold", fontSize:"16px", color:"#d0cccc", marginTop:"-5px", marginRight:"5px"}}>S</span> Season not active
              </li>
              <li style={{ display: "flex" }}>
              <span style={{fontWeight: "bold", fontSize:"11px", color:"#232121", marginRight:"5px"}}>Blank Space</span> No Seasons defined or applicable
              </li>
            </ul>
        ),
        renderCell: (props) => {
          const item = props.row;
          const seasonalityMonths = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
          const seasonalityConfig = item?.seasonalityConfig && item?.seasonalityConfig[0];
          const currentMonth = new Date().getMonth();
          let buttonContent = { textContent: "", textColor: "" };
          if (seasonalityConfig) {
            for (let i = currentMonth; i <= seasonalityMonths.length; i++) {
              if (i === currentMonth && seasonalityConfig[seasonalityMonths[i]] !== 0  && item.selMnthStlmts > item.settlementThreshold) {
                buttonContent.textContent = `S-${item.selMnthStlmts}`;
                buttonContent.textColor = "red";
                break;
              }
              if (
                i === currentMonth &&
                seasonalityConfig[seasonalityMonths[i]] !== 0
              ) {
                buttonContent.textContent = `S-${item.selMnthStlmts}`;
                buttonContent.textColor = "green";
                break;
              }
              if (seasonalityConfig[seasonalityMonths[i]] !== 0) {
                buttonContent.textContent = `S`;
                buttonContent.textColor = "grey";
                break;
              }
            }
          }
          return buttonContent.textContent ? (
            <Button
              variant="outlined"
              style={{ padding: "2px", color: buttonContent.textColor }}
              disabled={true}
              disableElevation
            >
              {buttonContent.textContent}
            </Button>
          ) : (
            <></>
          );
        },
      },
    },
    {
      label: "Activity",
      name: "activity",
      options: {
        searchable: false,
        filter: true,
        display: isVisible("activity"),
        hint: "INIT: Initial Fill, NORM: Replenishment, DISP: Disposal, NOPH: Non-Physical, PREM: Product Removal",
        renderCell: (props) => {
          const dataIndex = parseInt(`${props.id}`);
          const item = props.row;
          if (item) {
            const act = item.activity;
            const planningDate = state.planningDate?.toISOString()?.split("T")[0];
            let _disabled:any = !(item.status === "S" && item.nextDeliveryAct === planningDate);
            let color = "green";
            switch (act) {
              case "INIT": {
                color = "yellow";
                break;
              }
              case "DISP": {
                color = "red";
                break;
              }
              case "NOPH": {
                color = "red";
                break;
              }
              case "PREM": {
                color = "red";
                break;
              }
            }
            color = disabled ? "grey" : color;

            if(item.ishistory || disabled){
              _disabled=true;
            }
            return (
              <Button
                variant="outlined"
                style={{ padding: "2px", color }}
                disabled={_disabled}
                disableElevation
                onClick={(event) => handleActClick(dataIndex,item.activity,event)}
              >
                {item.activity}
              </Button>
            );
          }
        },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return handleUndefined(params, filterItem);
              };
            },
            label: "equals",
            value: "activity",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.act.map((v: any) => (
                  <option value={v}>{v}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "activity_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.act.map((v: any) => (
                  <option value={v}>{v}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    },
    {
      label: "Route",
      name: "routeAct",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("routeAct"),
        renderCell: (props) => {
          const dataIndex = parseInt(`${props.id}`);
          const item = props.row;
          const planningDateStr = state?.planningDate?.toISOString()?.split("T")[0];

          if(item.ishistory){
            setDisabled(true);
         }
          if (item) {
            if (item.routeAct) {
              return (
                <>
                  <Link component="button" disabled={disabled} onClick={(event) => handleRouteClick(dataIndex,item.customerNum,salesOrg,planningDateStr,event)}>
                    {item.routeAct}
                  </Link>
                  <Checkbox disabled={disabled}
                    checked={selectedRoutes.includes(dataIndex)}
                    onChange={(event) => {handleRouteCheckBoxSelection(dataIndex, event)}}
                    // inputProps={{ 'aria-label': 'controlled' }}
                  />
                </>
              );
            }
          }
        },
      },
    },
    {
      label: "Master Route",
      name: "routePlan",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("routePlan"),
        renderCell: (props) => {
          const dataIndex = parseInt(`${props.id}`);
          const item = props.row;
          if (item) {
            if (item.routePlan) {
              return item.routePlan;
            }
          }
        },
      },
    },
    {
      label: "Priority",
      name: "priority",
      options: {
        filter: true,
      },
    },
    {
      label: "VPR Status",
      name: "vprStatus",
      options: {
        searchable: false,
        filter: false,
        renderCell: (value: any) => {
          return (
            <IconButton
              onClick={() => {
                setCurKeys({
                  requestNum: value.row.reqNum,
                  salesOffice: value.row.salesOffice,
                  customerNum: value.row.customerNum,
                  customerName: value.row.name1 + " [" + value.row.name3 + "]",
                });
                setDisplayPIP(true);
              }}
              disableRipple
            >
              <GetStatusBadge status={value?.value} codes={codes} />
            </IconButton>
          );
        },
      },
    },
    {
      label: "VPR No",
      name: "reqNum",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("reqNum"),
        hint: "VPR Request Number",
      },
    },
    {
      label: "EFR",
      name: "effective_fill_rate",
      valueGetter : (props) => {
        const elemets = props.row;
        return parseFloat(Math.min(elemets?.effective_fill_rate, 100).toFixed(2))
      },
      options: {
        filter: true,
        searchable: false,
        type: "number",
        hint: "Effective Fill Rate of Space2Sales consignment levels",
        renderCell: (value: any) => {
          return `${Math.min(value?.value, 100).toFixed(2)}%`
        },
      },
    },
    {
      label: "VPR Date",
      name: "requestedDt",
      options: {
        searchable: false,
        filter: false,
        renderCell: (value: any) => {
          return `${value?.value ? formatDate(value?.value) : ""}`;
        },
      },
    },
    {
      label: "VPR SAP No",
      name: "sapRequestNumber",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("sapRequestNumber"),
        hint: "VPR SAP Request Number",
      },
    },
    //----------------end
    {
      label: "Next Delivery",
      name: isFutureDate?"sheduledNewDate":"nextNewDeliveryAct",
      options: {
        searchable: false,
        filter: true,
        type: "date",
        display: isFutureDate?isVisible("sheduledDate"):isVisible("nextDeliveryAct"),
        renderCell: (props) => {
          const item = props.row;
          const dataIndex = parseInt(`${props.id}`);
          if (item) {
            if (item.nextDeliveryAct && state.planningDate<new Date()) {
              return (
                <>{item.sheduledDate?item.sheduledDate.toString().split("T")[0]:''}</>
                );
            }
           else if (item.nextDeliveryAct) {
              return (
                <> 
                {item.sheduled.length>1?
                  <Link component="button" onClick={() => (disabled != true ? sheduleBtn(item.sheduled, dataIndex) : null)} style={{
                    backgroundColor:"#a3181d",
                      padding:'4px 6px',
                      borderRadius: '4px',
                      color: '#fff'
                    }}>
                    {item.sheduledDate?item.sheduledDate.toString().split("T")[0]:''}
                  </Link>:
                  (<div style={{
                    borderRadius: '4px',
                    color: '#e9232a'
                    }}>{item.sheduledDate?item.sheduledDate.toString().split("T")[0]:''}</div>)
                  }
                </>
              );
            }else{
              return <></>;
            }
          }else{
              return <></>;
            }
        },
      },
    },
    {
      label: "Proposed Del",
      name: "nextDeliveryPlan",
      options: {
        searchable: false,
        filter: true,
        type: "date",
        display: isVisible("nextDeliveryPlan"),
        renderCell: (props) => {
          let disabled=false;
          const item: any = props.row;
          if(item.ishistory){
            disabled=true;
         }
          if (item) {
            if (item.nextDeliveryPlan) {
              return (
                <Link  disabled={disabled} component="button" onClick={() => handleInvClick(item)}>
                  {item.nextDeliveryPlan.toString().split("T")[0]}
                </Link>
              );
            }
          }
        },
      },
    },
    {
      label: "Last Del",
      name: "lastDelivery",
      options: {
        searchable: false,
        filter: true,
        type: "date",
        display: isVisible("lastDelivery"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.lastDelivery) {
              return item.lastDelivery.toString().split("T")[0];
            }
          }
        },
      },
    },
    {
      label: "Last Inv Update",
      name: isFutureDate?"lastInventoryUpdate":"lastInvUpdate",
      options: {
        searchable: false,
        filter: false,
        type: "date",
        hint: "Last Inventory Updated On",
        display:isFutureDate?isVisible("lastInventoryUpdate"): isVisible("lastInvUpdate"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.lastInventoryUpdate) {
              return dateFormatter(new Date(item.lastInventoryUpdate), 'YYYY-MM-DD hh:mm');
            }
          }
        },
      },
    },
    {
      label: "DRI",
      name: "dri",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("dri"),
        hint: "Sales Days remaining Inventory",
      },
    },
    {
      label: "PFR",
      name: "pfr",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("prf"),
        hint: "Projected Fill Rate",
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.pfr) {
                return item.pfr + "%";
              }
            }
          }
        },
     
    },
    {
      label: "PFR@OOS",
      name: "pfrc",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("pfrc"),
        hint: "Projected Fill Rate when critical material runs out of stock",
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.pfrc) {
              return item.pfrc + "%";
            }
          }
        },
      },
    },
    {
      label: "PFU",
      name: "pfu",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("pfu"),
        hint: "Projected Fill Units",
      },
    },
    {
      label: "INV",
      name: "inv",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("inv"),
        hint: "Projected Inventory",
      },
    },
    {
      label: "CAP",
      name: "cap",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("cap"),
        hint: "Total Consigned Capacity",
      },
    },
    {
      label: "W-Vends/Day",
      name: "materialConsumption",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("materialConsumption"),
        hint: "Weighted Vends Per Day",
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.materialConsumption) {
              return item.materialConsumption.toFixed(2);
            }
          }
        },
      },
    },
    {
      label: "LFR",
      name: "lastFillRate",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("lastFillRate"),
        hint: "Last Settlement Fill Rate",
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.lastFillRate) {
              const perc = item.lastFillRate * 100;
              return perc.toFixed(0) + "%";
            }
          }
        },
      },
    },
    {
      label: "FTC",
      name: "ftc",
      options: {
        filter: false,
        searchable: false,
        hint: "Fill To Capacity",
        renderCell: (props) => {
          const dataIndex = parseInt(`${props.id}`);
          const item: any = props.row;
          if (item) {

            let _disabled=false;
            
            const planningDate = state.planningDate?.toISOString()?.split("T")[0];
            _disabled= !(item.status === "S" && item.nextDeliveryAct === planningDate&&item.activity!='DISP'&&item.activity!='PREM');
        
            if(item.ishistory || disabled){
              _disabled=true;
            }

            return (
              <FormControlLabel
                label=""
                control={<Checkbox disabled={_disabled} checked={item.ftc} onClick={(event) => handleFTCClick(item, dataIndex, event)} />}
              />
            );
          }
        },
      },
    },
    {
      label: "Equipment",
      name: "equipmentNum",
      options: {
        filter: false,
        searchable: true,
        display: isVisible("equipmentNum"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            if (item.equipmentNum) {
              return item.equipmentNum.replace(/^0+/, "");
            }
          }
        },
      },
    },
    {
      label: "Asset",
      name: "assetNum",
      options: {
        filter: false,
        searchable: true,
        display: isVisible("assetNum"),
      },
    },
    {
      label: "Model",
      name: "model",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("model"),
      },
    },

    {
      label: "Online",
      name: "online",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("online"),
        renderCell: (props) => {
          const item = props.row;
        
          if (item) {
            return RenderOnline(item)
          }
        },
        hint: (
          <>
            {" "}
            <ul className={classes.tooltip}>
              <li style={{ display: "flex" }}>
                <SettingsInputAntennaIcon style={{ color: "#4CAF50" }} /> Online
              </li>
              <li style={{ display: "flex" }}>
                <SettingsInputAntennaIcon style={{ color: theme.palette.mode == "dark" ? "#fff" : "#000" }} /> Exceeded
              </li>
              <li style={{ display: "flex" }}>
                <SettingsInputAntennaIcon color="primary" /> DexErrors
              </li>
              <li style={{ display: "flex" }}>
                <SettingsInputAntennaIcon style={{ color: "#ef5602" }} /> DexErrors And exceeded{" "}
              </li>
              <li style={{ display: "flex" }}>
                <SettingsInputAntennaIcon style={{ color: "#ff0" }} /> Telemeter Replaced{" "}
              </li>
              <li style={{ display: "flex" }}>
                <SettingsInputAntennaIcon style={{ color: "#9C27B0" }} /> NFK Processed{" "}
              </li>
            </ul>
          </>
        ),
      },
    },
    {
      label: "NFK",
      name: "isFKMissed",
      valueGetter : (props) => {
        const elemets = props.row;
        return (elemets.isFKMissed ? "Yes" : "No");
      },
      options: {
        filter: true,
        searchable: true,
        display: isVisible("isFKMissed"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            //for history records, if item.nfk = 2, then it's a default enum for empty
            if(item.ishistory)
              {
                  return ((item.nfk===2) ? "" : (item.nfk ? "Yes" : "No"));
              }
            
            //If machine is offline machine then NFK column should be empty
            if(!item.online)
              return "";

            //For online machine
            return (item.isFKMissed ? "Yes" : "No");
          }
        }
      },
    },
    {
      label: "Bank",
      name: "bank",
      options: {
        searchable: false,
        filter: false,
        display: isVisible("bank"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            const isBanked = item.bank != "";
            let disabled=false;
           
            if(item.ishistory){
              disabled=true;
           }

            return (
              <FormControlLabel
                label=""
                control={
                  <Checkbox  disabled={disabled}
                    name="active"
                    color="primary"
                    onClick={() => {
                       setTabIndex(1);
                       setCustomerLoaded(item.customerNum);
                       window.open(`/customer/${item.customerNum as any}`, "_blank");
                    }}
                    checked={isBanked}
                  />
                }
              />
            );
          }
        },
      },
    },
    {
      label: "Name",
      name: "name",
      options: {
        searchable: true,
        filter: true,
        display: isVisible("name"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            return <Typography>{item.name}</Typography>;
          }
        },
      },
    },
    {
      label: "Address",
      name: "street",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("street"),
      },
    },
    {
      label: "Location",
      name: "location",
      options: {
        filter: false,
        searchable: false,
        display: isVisible("location"),
      },
    },
    {
      label: "City",
      name: "city",
      options: {
        filter: false,
        searchable: true,
        display: isVisible("city"),
      },
    },
    {
      label: "Schedule",
      name: "schedulingMethod",
      options: {
        searchable: false,
        filter: true,
        display: isVisible("schedulingMethod"),
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return handleUndefined(params, filterItem);
              };
            },
            label: "equals",
            value: "schedulingMethod",
            InputComponent: (props: any) => {
              return (
                <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                  {filterDropDowns.schedule.map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text}
                    </option>
                  ))}
                </GridFilterInputValue>
              );
            },
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "schedulingMethod_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.schedule.map((v: any) => (
                  <option value={v.code}>
                    {v.code} - {v.text}
                  </option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    },
    {
      label: "Access Days",
      name: "prefDays",
      options: {
        searchable: false,
        display: isVisible("accessDays"),
        renderCell: (props) => {
          const item = props.row;
          if (item) {
            return <Typography style={{ color: "green" }}>{item.prefDays}</Typography>;
          }
        },
        filter: true,
        filterType: "dropdown",
        filterOptions: {
          names: ["1-M", "2-Tu", "3-W", "4-Th", "5-F", "6-Sa", "7-Su"],
          logic(ad: any, filterVal: any) {
            var isAcc = false;
            filterVal.forEach((filter: string) => {
              const wd = filter.split("-")[1];
              if (ad.includes(wd)) {
                isAcc = true;
              }
            });
            return !isAcc;
          },
        },
        sort: false,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if (filterItem.value !== undefined) {
                  return params.value.toLowerCase().includes(filterItem.value.toLowerCase());
                }
                return false;
              };
            },
            label: "contains",
            value: "prefDays_contains",
            InputComponent: (props: any) => <GridFilterInputValue {...props}></GridFilterInputValue>,
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return handleUndefined(params, filterItem);
              };
            },
            label: "equals",
            value: "prefDays",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.accessDays.map((v: any) => (
                  <option value={v}>{v}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "prefDays_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.accessDays.map((v: any) => (
                  <option value={v}>{v}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    },
    {
      label: "Sales Days",
      name: "salesDays",
      options: {
        searchable: false,
        display: isVisible("salesDays"),
        filter: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return handleUndefined(params, filterItem);
              };
            },
            label: "equals",
            value: "salesDays",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.salesDays.map((v: any) => (
                  <option value={v}>{v}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "salesDays_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {filterDropDowns.salesDays.map((v: any) => (
                  <option value={v}>{v}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    },
    {
      label: "Online Status ",
      headerClassName: "hide",
      name: "exceededDays",
      valueGetter: (props) => {
        const item: any = props.row;
        let showMessage: string = "";
        
        if (item.online && item.online != "") {

          if (item.online && item.dexErrors) {
            showMessage = "DexErrors";
          }

          if (item.online && item.exceededStatus) {
            showMessage = "Exceeded";
          }
          if (item.online && item.dexErrors && item.exceededStatus) {
            showMessage = "DexErrors And Exceeded";
          }
          if (item.online && item.dexErrors == false && item.exceededStatus == false) {
            showMessage = "Online";
            if(item.isFKMissed){
              showMessage = "NFk Processed";
            }
          }
          
          if (item.online && item.telemeterReplaced) {
            showMessage = "Telemeter Replaced";
          }

          if(item.ishistory){
            if(item.online == 0){
              showMessage = "DexErrors";
            }else if(item.online == 1){
              showMessage = "Exceeded";
            }else if(item.online == 2){
              showMessage = "DexErrors And exceeded";
            }else if(item.online == 3){
              showMessage = "Online";
            }else if(item.online == 4){
              showMessage = "Telemeter Replaced";
            }else if(item.online == 5){
              showMessage = "NFK Processed";
            }
          }

          return showMessage;
        }
      },
    },
    {
      label: 'SGN',
      name:'groupName',
      options: {
        searchable: false,
        filter: true,
        // display: isVisible("groupName"),
        hint: "Service Group Name",
      }
    },
    {
      label: isFutureDate?"Last Confirmed":"Release Date",
      name: isFutureDate?"last_confirm_dt":"last_confirm_dt",
      options: {
        searchable: false,
        filter: true,
        hint: isFutureDate?"Last Confirmed Date":"Release Date",
        type: "date",
        display: isFutureDate?isVisible("last_confirm_dt"):isVisible("last_confirm_dt"),
        renderCell: (props) => {
          const item = props.row;
          // if (item.expectedFills.length>0) {
          //   let confirmDate= '';
          //   if (item.expectedFills.length>1) {
          //     const vsday = new Date(state?.planningDate).getTime();
          //      confirmDate = item.expectedFills.reduce((a:any, b:any) => 
              
          //     (vsday<=new Date(a.fillDt).getTime() && vsday<=new Date(b.fillDt).getTime())?(new Date(a.fillDt).getTime() - vsday < new Date(b.fillDt).getTime() - vsday )?a.fillDt:b.fillDt:b.fillDt
              
          //     );
          //   } else {
          //      confirmDate =   item.expectedFills[0].fillDt;
          //   }
          //   return moment(confirmDate).toString().split("T")[0];
          // }
          // else{
          //   return  item.last_confirm_dt&& item.last_confirm_dt!='1900-01-01'?moment(item.last_confirm_dt).toISOString().split("T")[0]:'';
          // }
          return item.last_confirm_dt&& item.last_confirm_dt!='1900-01-01'?new Date(item.last_confirm_dt).toISOString().split("T")[0]:'';

         // return moment((item.releaseDate)).toISOString().split("T")[0];
         
        },
      },
    },
    {
      label: "Zip code",
      name: "zipcode",
      options: {
        filter: true,
        searchable: false,
        display: isVisible("zipcode"),
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if (filterItem.value !== undefined) {
                  return params.value.toLowerCase().includes(filterItem.value.toLowerCase());
                }
                return false;
              };
            },
            label: "contains",
            value: "zipcode_contains",
            InputComponent: (props: any) => <GridFilterInputValue {...props}></GridFilterInputValue>,
          },
        ],
      },
    },
    {
      label: "SSI",
      name: "settlementCount",
      valueGetter : (props) => {
        const elemets = props.row;
        return parseInt(elemets?.settlementSinceInitial || 0)
      },
      options: {
        filter: true,
        hint: "Settlement Since Initial",
        searchable: true,
        display: true,
        renderCell: (props) => {
          const item = props.row;
          return (item?.settlementSinceInitial || 0).toString();
        },
      },
    }
  ];






  const customToolbar = () => {
    //  const data = [{id: '1', name: 'Normal'}, {id: '2', name: 'Overlay'}];
let is_disable=false
if(new Date(props.data.planningDate).toISOString().split('T')[0]<new Date().toISOString().split('T')[0]){
  is_disable=true
}
if(disabled){
  is_disable=true
}

    return (
      <React.Fragment>
         <Tooltip title={"Filter for Overdue Machines Only"} >
          <IconButton disabled={is_disable || isDisplayOnlyRole} onClick={() => handleOverdueClick()}  >
            <NotificationImportantIcon  />
          </IconButton>
        </Tooltip>
        <Tooltip title={"Schedule planned"}> 
          <IconButton disabled={is_disable || isDisplayOnlyRole} onClick={() => handleScheduleTodayClick()}>
            <AddAlert />
          </IconButton>
        </Tooltip>
        {hasScheduledVisit ? (
          <>
            <Tooltip title={"Unschedule planned"}>
              <IconButton disabled={is_disable || isDisplayOnlyRole} onClick={() => handleResetClick()}>
                <UndoIcon />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          ""
        )}
        <br />
        {/* <IconButton onClick={() => {}}>
            <ListIcon/>
          </IconButton>    */}
        {/* <Grid item xs={1} md={1} lg={1} xl={1}>
         <TextField
         fullWidth
         label="Map Mode"
         value={modeValue}
         select
         onChange={handleModeChange}
         >
           {data.map((option: any) => (
         <MenuItem key={option.id} value={option.name}>
           {option.name}
         </MenuItem>
          ))} 
        </TextField>
        </Grid>  */}
        <Tooltip title={"Show Map View"}>
          <IconButton disabled={is_disable} onClick={() => handlePlanMapViewClick()}>
            <MapIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title={"Refresh"}>
          <IconButton onClick ={() => handleRefreshClick()} disabled= {state.planningData?.length == 0}>
            <SyncIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title={"Change Route"}>
          {selectedRoutes?.length > 0 ? (
            <Button disabled={is_disable || isDisplayOnlyRole} color="primary" size="small" variant="outlined" onClick={() => checkForNonMatNMult()}>
              Change Route
            </Button>
          ) : (
            <div />
          )}
        </Tooltip>
        {statusOflist == 1 ? (
          // <Button  disabled={is_disable} color="primary" size="small" variant="outlined" onClick={() => handleReplanClick()}>
          <Button  disabled={is_disable || isDisplayOnlyRole} color="primary" size="small" variant="outlined" onClick={() => setAlertReplan(true)}>
            Replan
          </Button>
        ) : (
          ""
        )}
        
   <Button disabled={(scheduleList.length > 0 ? unscheduleList.length > 0 : true) || isDisplayOnlyRole} color="primary" size="small" variant="outlined" onClick={() => handleBulkSchedule()}>
    schedule
    </Button> <Button disabled={(unscheduleList.length > 0  ? scheduleList.length > 0 : true) || isDisplayOnlyRole} color="primary" size="small" variant="outlined"  onClick={() => handleBulkUnschedule()}>
    unschedule
    </Button>
    {
    selectedRoutesCkecks.length>0?<>
    <Button color="primary" size="small" variant="outlined"  disabled={isDownloadRoutecard} onClick={() => handleDownLoadPDF()}>
    Download Route Card
    </Button> </>: ''
    }
    
    { (isReviewFeatureEnabled && statusOflist == 0 && readyToReviewStatusValue && readyToReviewStatusValue == 3) ? (
        <Button  color="success" size="small" variant="contained"  onClick={() => handleReadyToReview()}>Reviewed</Button>
      ) : (isReviewFeatureEnabled && statusOflist == 0 && readyToReviewStatusValue && readyToReviewStatusValue == 2) ? (
        <Button color="primary" size="small" variant="contained"  onClick={() => handleReadyToReview()}>Ready To Review</Button>
      ): (
        (isReviewFeatureEnabled && statusOflist == 0 && readyToReviewStatusValue && !isDisplayOnlyRole)?
          <Button disabled={!enableReadyToReview || isDisplayOnlyRole} color="primary" size="small" variant="outlined"  onClick={() => handleReadyToReview()}>Ready To Review</Button>:
          <></>
      )
    }
      </React.Fragment>
    );
  };
  
  // if we change the table, the stored sequence becomes invalid. Fix this here.
  if (colSequence.length != columns.length) {
    var arr = new Array<number>();
    for (var i = 0; i < columns.length; i++) {
      arr.push(i);
    }
    setColSequence(arr);
  }
  /****
   *
   *  SheduleItems
   *
   */

  const SheduleItems = (item: PlanningItem) => {
    //if display only role return;
    if(isDisplayOnlyRole){
      return;
    }
    const index = state.planningData.findIndex((x: any) => x.customerNum === item.customerNum);
    const clone = JSON.parse(JSON.stringify(item));
    if(clone.status!='C'){
      clone['history']={}
      let cus:any=RenderCustomer(item);
      clone.history["customer_status"]=cus?.props.id || '';
      clone.history["customer_msg"]=cus?.props.title || '';
      let exe_status=RenderExceeded_Status(item)  
      if(exe_status){
        if(exe_status=='DexErrors_Exceeded'){
          clone.history["exceeded_status"]='DexErrors_Exceeded'
        }
        else{
          clone.history["exceeded_status"]=exe_status
        }
      }else{
        clone.history["exceeded_status"]=null
      }

        let online = RenderOnline(item);
        if(online){
          clone.history["online"]=online?.props?.children?.props?.id ;
          clone.history["online_msg"]=online?.props?.children?.props?.title;
        }
        else{
          clone.history["online"]=null;
          clone.history["online_msg"]=null
        }
       
      let statuss= RenderStatus(item) ;

      if(statuss){
        clone.history["status_msg"]=statuss?.props.title || '';;
      }   
    }
    //setting nfk for confirmed histor table in cae of online machine only
    //If offline machine set 2
    clone["nfk"] = !clone.online ? 2 :(clone.online && clone.isFKMissed) ? 1 : 0;
    sheduleAction(clone, index);
  };

  /***
   *
   *  Shedule  Logic
   *
   */

  const sheduleAction = (item: any, index: any) => {
    item.loading = true;
    savingActive=true;
    savingCustNum=item.customerNum;
    var newStatus = "P";
    var newDate = new Date(state.planningDate);
    var isValid = false;
    // what is the current status?
    if (item.status === "P" || item.status === "C") {
      newStatus = "S";
      isValid = true;
    }
    if (item.status === "S") {
      // this item is already scheduled. If we are planning for another day, change the date. If not, unschedule it
      if(item.routeAct!==item.routePlan){
        if(adminSettingEnable==1){
          setRouteItem(item);
          setRouteItemIndex(index);
          setConfirmRouteReset(true);
        }else{
          setMoveToMasterRoute(item,index);
        
        }
      }else{
        if (item.nextDeliveryAct === state?.planningDate?.toISOString()?.split("T")[0]) {
          newDate = new Date(item.nextDeliveryAct);
          newStatus = "P";
        } else {
          
          newStatus = "S";
        }
        isValid = true;
      }
    }
    //
    //Dispaly only role review functionality
    //Checking if customer belong to different route and does have review comment for change route
    //and user tries to schedule it, so will provide an alret to before sceduling
    if(!isReviewChangeRouteConfirm && item.status == "P" && props.data.selectedRoute != item.routePlan && item?.txVisitPlanningReview && item?.txVisitPlanningReview.length){
        if(item?.txVisitPlanningReview?.routePlan != item.routePlan){
          setRouteItem({...item, routeAct: item?.txVisitPlanningReview[0]?.routePlan});
          setRouteItemIndex(index);
          setIsReviewChangeRouteConfirm(true);
          setReviewChangeRouteDialog(true);
          return;
        }
    }

    if (isValid) {
      const actData = {
        ...item,
        plant: state.selectedDeliveryPlant,
        route: item.routeAct,
        loadDate: item.nextDeliveryAct,
        customerNum: item.customerNum,
        equipmentNum: item.equipmentNum,
        activity: item.activity,
        
      };
      
      const customerArr = [actData];
      let planningData = [item];

      // let t1 = {...planningData?.cancelVisitDate?.[0], ...{'msg': 'Pushing Msg'}}; 

      setPlanningStatus(salesOrg.toString(), customerArr, newStatus, newDate,'',uuid).then((v: string) => {
        if (v) {
          // setDisabled(false);
          item.loading = false;
         
        }
        if(v === "D"){
          item.loading = false;
          setErrorRouteMessage({
            validate:false,
            message:`Material Discrepancy Found ! Please verify materials for customer${customerArr[0].customerNum}`
         });
         return;
        }else if(v === "C"){
          item.loading = false;
          setErrorRouteMessage({
            validate:false,
            message:'already got confirmed Please refresh and retry'
         });
        }
        if (v === "S") {
          // update successful, now update local structure w/o reloading everything
          item.status = newStatus;
          item.activity = item.equipmentStatus;
          item.nextDeliveryAct = newDate?.toISOString()?.split("T")[0];
          let dates=newDate.toISOString().split("T")[0];
         
          if(newStatus==='S'){
            if(item.sheduled.length>0){
             // let datess= item.sheduled.find((a:any) => a.visit_dt_pltan <= dates);
              item.sheduled.push({
                customer_num:item.customerNum,
                visit_dt_plan:newDate?.toISOString()?.split("T")[0],
                route_act: item.routeAct
              })
             
              const minDate = new Date(
                Math.min(
                  ...item.sheduled.map((element:any )=> {
                    return new Date(element.visit_dt_plan);
                  }),
                ),
              );
              item.sheduledDate=minDate.toISOString().split("T")[0];
              //item.nextDeliveryAct=minDate.toISOString().split("T")[0];
              // if(datess){
              //   item.sheduledDate=datess.visit_dt_plan;
              // }else{
              //   item.sheduledDate=newDate.toISOString().split("T")[0]
              // }
            }else{
             
              item.sheduledDate=newDate.toISOString().split("T")[0];
              item.nextDeliveryAct = newDate.toISOString().split("T")[0];
            }
          }
          else{
            if(item.sheduled.length>0){
              item.sheduled.splice(item.sheduled.findIndex((a:any) => a.visit_dt_plan === dates) , 1)
              const minDate = new Date(
                Math.min(
                  ...item.sheduled.map((element:any )=> {
                    return new Date(element.visit_dt_plan);
                  }),
                ),
              );
              

                if(item.sheduled.length>0){
                item.sheduledDate=minDate.toISOString().split("T")[0];
                item.nextDeliveryAct = minDate.toISOString().split("T")[0];
                
              }else{
                item.sheduledDate= item.nextDeliveryPlan;
                item.nextDeliveryAct = item.nextDeliveryPlan;
              }
            }else{
              item.sheduledDate= item.nextDeliveryPlan;
              item.nextDeliveryAct = item.nextDeliveryPlan; //newDate.toISOString().split("T")[0];
            }
            item.ftc=false;
          }
         
          let newObj = bulkItems.filter((cus:any) => cus.customerNum !== item.customerNum);
           setbulkItems(newObj);

           const nRoutes = selectedRoutesCkecks?.filter((item: number) => item !== index);
           setSelectedRoutesCkecks(nRoutes);
          //  if(newStatus==='S'){
          //   setUnbulkshedule(false)
          //  }else{
           
            setbulkshedule(false);
            
           //}
          //bulkItems.set(item.customerNum,item)
          props.change(item, index);
          GetEssentialData(salesOrg, state.planningDate || "", '', '100').then((data:any) => {
           setEssData(data)             
          });
        }
        savingActive=false;
        savingCustNum='';
      });
    }
  };
const setMoveToMasterRoute = (item:any, index:any) => {
    var items = state.planningData;
    item.loading = true;
    savingActive=true;
    savingCustNum=item.customerNum;
    var newStatus = "P";
    var newDate = new Date(state.planningDate);
    var isValid = false; 
    if (item.nextDeliveryAct === state?.planningDate?.toISOString()?.split("T")[0]) {
      newDate = new Date(item.nextDeliveryAct);
      newStatus = "P";
    } else {
      
      newStatus = "S";
    }
    isValid = true;

    if (isValid) {
   
      const actData = {
        ...item,
        plant: state.selectedDeliveryPlant,
        route: item.routeAct,
        loadDate: item.nextDeliveryAct,
        customerNum: item.customerNum,
        equipmentNum: item.equipmentNum,
        activity: item.activity,
      };
      const customerArr = [actData];
      setPlanningStatus(salesOrg.toString(), customerArr, newStatus, newDate, actData,uuid).then((v: string) => {
        if (v) {
          // setDisabled(false);
          item.loading = false;
        }
        if (v === "S") {
          //
          if(item?.txVisitPlanningReview && item?.txVisitPlanningReview.length 
            && props.data.selectedRoute != item.routePlan && item.routePlan != item?.txVisitPlanningReview[0]?.routePlan){
              item.routeAct = item.routePlan;
              item.status = newStatus;
              //
              let dates=newDate.toISOString().split("T")[0];
              if(item.sheduled.length>0){
                  item.sheduled.splice(item.sheduled.findIndex((a:any) => a.visit_dt_plan === dates) , 1)
                  const minDate = new Date(
                  Math.min(
                    ...item.sheduled.map((element:any )=> {
                    return new Date(element.visit_dt_plan);
                    }),
                  ),
                  );
                  

                  if(item.sheduled.length>0){
                  item.sheduledDate=minDate.toISOString().split("T")[0];
                  item.nextDeliveryAct = minDate.toISOString().split("T")[0];
                  
                  }else{
                  item.sheduledDate= item.nextDeliveryPlan;
                  item.nextDeliveryAct = item.nextDeliveryPlan;
                  }
              }else{
                item.sheduledDate= item.nextDeliveryPlan;
                item.nextDeliveryAct = item.nextDeliveryPlan; //newDate.toISOString().split("T")[0];
              }
              //item.sheduled = [];
              items[index] = item;
          }else{
            items.splice(index, 1);
          }
          
          props.changeAll(items);
        }
      });
    }
  }

  const setBatchMoveToMasterRoute = (items:any) => {
    let newDate = new Date(state.planningDate);
    let obj:any=[]
    let newStatus='P'
    items.forEach((elements: { status: string; }) => {
      if(elements.status==='S'){
        obj.push(elements)
      }
    }
    )
    if(obj.length>0){
      setbulkUnSchedule( state.selectedSalesOffice, state.selectedRoute,salesOrg.toString(), newStatus, newDate,obj,uuid).then((v: string) => {
        if (v === "S") {
          /** 
           * removing the items fom current route when they moved to their master route
          */
          //const stateObjectItems = _.cloneDeep(state.planningData);
          obj.forEach((item: any) => {  
              //Finding & removing the state object
              const index = planningDataStore.findIndex((obj: any) => obj.customerNum === item.customerNum);
              if (index !== -1) {
                if(props.data.selectedRoute != item.routePlan && item?.txVisitPlanningReview && item?.txVisitPlanningReview.length){
                  item.routeAct = item.routePlan;
                  item.status = newStatus;
                  let dates=newDate.toISOString().split("T")[0];
                  if(item.sheduled.length>0){
                      item.sheduled.splice(item.sheduled.findIndex((a:any) => a.visit_dt_plan === dates) , 1)
                      const minDate = new Date(
                      Math.min(
                        ...item.sheduled.map((element:any )=> {
                        return new Date(element.visit_dt_plan);
                        }),
                      ),
                      );
                      

                      if(item.sheduled.length>0){
                      item.sheduledDate=minDate.toISOString().split("T")[0];
                      item.nextDeliveryAct = minDate.toISOString().split("T")[0];
                      
                      }else{
                      item.sheduledDate= item.nextDeliveryPlan;
                      item.nextDeliveryAct = item.nextDeliveryPlan;
                      }
                  }else{
                    item.sheduledDate= item.nextDeliveryPlan;
                    item.nextDeliveryAct = item.nextDeliveryPlan; //newDate.toISOString().split("T")[0];
                  }
                  //item.sheduled = [];
                  planningDataStore[index] = item;
                }else{
                  planningDataStore.splice(index, 1);
                }
              }       
          });
          //to remove id and extra data which is not needed, also to prevent item id mismatch which 
          //causing item to remove itself due to id mismatch
          planningDataStore.map((ele: any) => {
              delete ele?.id;
          });
          props.changeAll(planningDataStore);
          setSelectedRoutesCkecks([]);
          setbulkItems([]);
          setbulkshedule(false);
          // setUnbulkshedule(false)
          // update successful, now update local structure w/o reloading everything
          //props.reloadAll();
        }
        setGridTableLoader(false);
      });
      
    }
  }

  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #ddd",
    background: "#f0f0f0",
  } as const;
  
  const handleReplanClick = () => {
    var newDate = new Date(state.planningDate).toISOString().split("T")[0];   //moment(state.planningDate).format("YYYY-MM-DD");

    

    // console.log(props.data.selectedRoute);
      replanUpdate(props.salesOrg, props.data.selectedRoute, newDate,props.data.selectedDeliveryPlant,uuid).then((res) => {
      pdfDeleteByRoute(props.salesOrg, props.data.selectedRoute, newDate,props.data.selectedDeliveryPlant).then((res) => {

        props.reloadAll();
      })
     
    });
  };
  const refreshData = () => {
    props.reloadAll();
  };

  const handleNoteSave = () => {
    let noteText=notesRef?.current?.value;
    if (noteText.trim()!=="") {
      if (new Date(selectedOptions?.validUntilDt)>=new Date(selectedOptions?.createdDt)) {
        const toSave: CustomerNotes[] = [];
        toSave.push({ ...selectedOptions, validUntilDt: new Date(new Date(selectedOptions.validUntilDt).setHours(23, 59, 59, 0)),text:noteText });
        // console.log("🚀 ~ file: Planning.tsx ~ line 1817 ~ handleNoteSave ~ toSave", toSave, selectedCustomer);
        PostNotes(salesOrg.toString(), selectedCustomer, toSave).then((v: any) => {
          setOpenEditWindow(false);
          setSelectedOptions(initialSelectedOptions);
          GetNotes(salesOrg.toString()).then((v) => {
            const result = v?.notes.reduce((result: any, currentValue: any) => {
              (result[currentValue?.customerNum] = result[currentValue?.customerNum] || []).push(currentValue);
              return result;
            }, {});
            // console.log("🚀 ~ file: index.tsx ~ line 247 ~ result ~ result", result);
            setNotes(result);
            updateCustomerNotes(result[selectedCustomer]);
          });
        });
      }else{
        setHandleDate(true);
        setAlert("Please enter the Valid Until Date greater or equal to Valid From Date.")
      }
    }else{
      setHandleDate(true);
      setAlert("Notes should not be empty.")
    }
  };
  const handleNoteDelete = () => {
    let UpdatedNotes= JSON.parse(JSON.stringify(notes));
    const toSave: CustomerNotes[] = [];
    toSave.push({ ...selectedOptions, isDeleted: true });
    // console.log("🚀 ~ file: Planning.tsx ~ line 1817 ~ handleNoteSave ~ toSave", toSave, selectedCustomer);
    PostNotes(salesOrg.toString(), selectedCustomer, toSave).then((v: any) => {
      setOpenEditWindow(false);
      setSelectedOptions(initialSelectedOptions);
      GetNotes(salesOrg.toString()).then((v) => {
        const result = v?.notes.reduce((result: any, currentValue: any) => {
          (result[currentValue?.customerNum] = result[currentValue?.customerNum] || []).push(currentValue);
          return result;
        }, {});
        
        setNotes(result);
        if( result[selectedCustomer]!=undefined){
            updateCustomerNotes(result[selectedCustomer]);
        }else{
          result[selectedCustomer]=[]
          updateCustomerNotes(result[selectedCustomer]);
        }
      });
    });
    UpdatedNotes=[]
  };

  const modalBody = (
    <div style={modalStyle} className={classes.paper}>
      <Typography variant="h4" className={classes.modalTitle} paragraph>
        Notes
      </Typography>
      <Grid container spacing={4} className={classes.modalGrid}>
        <Grid item xs={12} md={12} xl={12}>
          <Typography variant="subtitle1" className={classes.modalText} paragraph>
            Add New Note 
          </Typography>
          <span className={classes.modalCard}>
            <CardContent>
              <Grid container spacing={3} className={classes.gridMarginTop}>
                <Grid item lg={4} xs={4} className={classes.gridSpaceable}>
                  <InputLabel sx={{fontSize:13}}>Note Type</InputLabel>
                  <Select
                    label="Note Type"
                    style={{width:'15rem',marginTop:'-3px'}}
                    value={selectedOptions?.noteType}
                    // disabled={n.isDeleted}
                    onChange={(ce) =>
                      setSelectedOptions({
                        ...selectedOptions,
                        noteType: typeof ce.target.value == "string" ? ce.target.value : "",
                      })
                    }
                  >
                    <MenuItem key="customer" value="CUSTOMER" >
                      CUSTOMER
                    </MenuItem>
                    <MenuItem key="driver" value="DRIVER">
                      DRIVER
                    </MenuItem>
                    <MenuItem key="dispatcher" value="DISPATCHER">
                      DISPATCHER
                    </MenuItem>
                    {/* {state.meta?.validTypes.map(vt=>(
                            <MenuItem value={vt.code}>{vt.text}</MenuItem>
                          ))} */}
                  </Select>
                </Grid>
                <Grid item lg={4} xs={4} className={classes.gridSpaceable}>
                <LocalizationProvider  dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disablePast={true}
                    label="Valid From" 
                    value={selectedOptions?.createdDt}
                    onChange={(e:any) => setSelectedOptions({ ...selectedOptions, createdDt: new Date(e) })}
                    renderInput={(props:any) => (
                      <TextField {...props} label="Valid From" fullWidth />
                      )}
                      />
                </LocalizationProvider>
                </Grid>
                <Grid item lg={4} xs={4} className={classes.gridSpaceable}>
                <LocalizationProvider  dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disablePast={true}
                    label="Valid Until" 
                    value={selectedOptions?.validUntilDt}
                    onChange={(e:any) =>setSelectedOptions({ ...selectedOptions, validUntilDt: new Date(e) })}
                    renderInput={(props:any) => (
                      <TextField {...props} label="Valid Until" fullWidth />
                      )}
                      />
                </LocalizationProvider>
                </Grid>
                {/* <Grid item lg={4} xs={4} className={classes.gridSpaceable}>
                  <TextField
                    contentEditable={false}
                    fullWidth={true}
                    // disabled={n.isDeleted}/
                    label="Created By"
                    value={selectedOptions?.createdBy}
                    // onChange={(e) => setSelectedOptions({ ...selectedOptions, createdBy: e.target.value })}
                  />
                </Grid> */}
              </Grid>
              <Grid item lg={12} xs={12}>
                     <TextField
                id="notes"
                name="notes"
                  fullWidth={true}
                  required={true}
                  multiline
                  rows={2}
                  inputProps={{ maxLength:300}}
                  // disabled={n.isDeleted}
                  label="Note"
                                    // value={selectedOptions?.text}
                  // onChange={(e) => setSelectedOptions({ ...selectedOptions, text: e.target.value })}
                  inputRef={notesRef}
                  defaultValue={selectedOptions?.text}
                />
              </Grid>
            </CardContent>
          </span>
          <div style={{ paddingRight: "5px", textAlign: "right" }}>
            <React.Fragment>
              <Tooltip title={"Save"}>
                <IconButton onClick={handleNoteSave} color="primary"  style={Pointer}>
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Cancel"}>
                <IconButton onClick={handleModalClose} color="primary"  style={Pointer}>
                  <Clear />
                </IconButton>
              </Tooltip>
            </React.Fragment>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const reviewCommentModalBody = (
    <div style={modalStyle} className={classes.paper}>
      <div style={{ display: 'flex', alignItems:"center", gap:"350px", marginLeft:"25px", marginBottom:"-25px"}}>
        <div title="Customer Number / Name / Equipement Number / Asset Number">
          <Typography variant="h6" className={classes.modalTitle} paragraph>
            Reviews: {`${state.planningData[reviewDialogData?.dataIndex]?.customerNum}
            /${state.planningData[reviewDialogData?.dataIndex]?.name1}
            /${state.planningData[reviewDialogData?.dataIndex]?.equipmentNum}
            /${state.planningData[reviewDialogData?.dataIndex]?.assetNum}`}
          </Typography>
        </div>
        <div style={{ marginTop: "-12px", alignItems:"end"}}>
          <React.Fragment>
            <Tooltip title={"Delete"}>
              <IconButton disabled={!reviewDialogData?.review || !isDisplayOnlyRole} onClick={handleReviewDataDelete} color="primary"  style={Pointer}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        </div>
      </div>
      <div style={{marginLeft:"25px"}}>
          <p title="Location / Route / Model / Status" style={{marginBottom:"-12px"}}>{`${state.planningData[reviewDialogData?.dataIndex]?.location} / 
          ${state.planningData[reviewDialogData?.dataIndex]?.routeAct} / ${state.planningData[reviewDialogData?.dataIndex]?.model} / ${state.planningData[reviewDialogData?.dataIndex]?.status}
          `}</p>
          <p title="Last Delivery / PFU" style={{display:"inline-block", marginRight:"5px"}}>{`${state.planningData[reviewDialogData?.dataIndex]?.lastDelivery?.split("T")[0]} / 
          ${state.planningData[reviewDialogData?.dataIndex]?.pfu} / 
          `}</p>
          {state.planningData[reviewDialogData?.dataIndex] ? <p style={{display:"inline-block"}}>{RenderOnline(state.planningData[reviewDialogData?.dataIndex])}</p>:<></>}
          
      </div>
      {reviewDialogData?.notesContent?.CUSTOMER ?
      <div style={{display:"inline-block"}}>
        <span title="Customer Notes" style={{display:"inline-block", marginLeft:"25px"}}><PersonIcon fontSize="small"   /></span>
        <div style={{marginLeft:"25px", width: "400px", height:"80px", overflow: "auto"}}>
          {reviewDialogData?.notesContent?.CUSTOMER.length && reviewDialogData?.notesContent?.CUSTOMER?.map((ele: any)=>{
          return (
            <p>{ele?.text}</p>
          )
          })}
        </div> 
      </div>:<></>}
       {reviewDialogData?.notesContent?.DRIVER ?
      <div style={{display:"inline-block"}}>
        <span title="Driver Notes" style={{display:"inline-block", marginLeft:"25px"}}><LocalShippingIcon fontSize="small" /></span>
        <div style={{ marginLeft:"25px", width: "400px", height:"80px", overflow: "auto"}}> 
          {reviewDialogData?.notesContent?.DRIVER.length && reviewDialogData?.notesContent?.DRIVER?.map((ele: any)=>{
          return (
            <p>{ele?.text}</p>
          )
          })}
        </div> 
      </div>:<></>}
      {reviewDialogData?.notesContent?.DISPATCHER ?
      <div style={{display:"inline-block"}}>
        <span title="Dispacther Notes" style={{display:"inline-block", marginLeft:"25px"}}><InfoIcon fontSize="small" /></span>
        <div style={{marginLeft:"25px", width: "400px", height:"80px", overflow: "auto"}}> 
          {reviewDialogData?.notesContent?.DISPATCHER?.length && reviewDialogData?.notesContent?.DISPATCHER?.map((ele: any)=>{
          return (
            <p>{ele?.text}</p>
          )
          })}
        </div>
      </div>: <></>}
      <Grid container spacing={4} className={classes.modalGrid}>
        <Grid item xs={12} md={12} xl={12}>
          <span className={classes.modalCard}>
            <CardContent>
              <Grid container spacing={3} className={classes.gridMarginTop}>
                <Grid item>
                  <TableContainer>
                    <Table sx={{minWidth:1300}}>
                      {!isDisplayOnlyRole ? <caption style={{captionSide:"top", textAlign:"center", marginBottom:"-15px"}}>Read Only Mode! Can't edit Status, Activity, Route OR FTC.</caption> :<></>}
                      <TableHead>
                        <TableRow>
                          <TableCell>Status</TableCell>
                          <TableCell>Activity</TableCell>
                          <TableCell>Route</TableCell>
                          <TableCell>FTC</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{pointerEvents: !isDisplayOnlyRole ? "none" : "auto"}}>
                        <TableRow>
                          <TableCell align="left">
                            {reviewDialogData?.schedulePlan === "P" ? 
                              <Tooltip title="Unscheduled">
                                <Button variant={"outlined"} style={{ padding: "2px"}} onClick={()=>{
                                  setReviewDialogData({...reviewDialogData, schedulePlan: "S"});
                                }}>
                                  <LocalShippingIcon/>
                                </Button>
                              </Tooltip>:
                            <Tooltip title="Scheduled">
                                <Button variant={"contained"} style={{ padding: "2px"}} onClick={()=>{
                                  let cloneReviewDialogData: any = {...reviewDialogData};
                                  if(cloneReviewDialogData?.masterRoute != cloneReviewDialogData?.routePlan){
                                    cloneReviewDialogData.routePlan = cloneReviewDialogData?.masterRoute;
                                  }
                                  if(cloneReviewDialogData?.activityPlan != "NORM" && (cloneReviewDialogData?.activityPlan != "NOPH" && reviewDialogData?.activityPlan != "INIT")){
                                    cloneReviewDialogData.activityPlan = "NORM";
                                  }
                                  if(cloneReviewDialogData?.ftcPlan == true){
                                    cloneReviewDialogData.ftcPlan = false;
                                  }
                                  setReviewDialogData({...cloneReviewDialogData, schedulePlan: "P"});
                                }}>
                                  <LocalShippingIcon/>
                                </Button>
                              </Tooltip>
                            }
                            
                          </TableCell>
                          <TableCell>
                            <Select
                              value={reviewDialogData?.activityPlan}
                              disabled={(reviewDialogData?.activityPlan == "NOPH" || reviewDialogData?.activityPlan == "INIT")}
                              label="Activity"
                              onChange={(e: any)=>{
                                let cloneReviewDialogData: any = {...reviewDialogData};
                                if(cloneReviewDialogData?.schedulePlan == "P" && cloneReviewDialogData?.initialActivity != e.target.value){
                                  const alert={
                                      alertTitle:'Review Alert',
                                      alertMessage:`Marking the customer as scheduled, because activity change requires customer to be in Scheduled status.`,
                                      isAlertOpen:true,
                                      alertProceedButton:false,
                                      alertDenyButton:false,
                                      alertDisable:false,
                                    };

                                  setCommonAlert(alert);
                                  cloneReviewDialogData = {...reviewDialogData, schedulePlan: "S"};
                                }else if(cloneReviewDialogData.initialStatus != "S" && cloneReviewDialogData?.schedulePlan == "S" && cloneReviewDialogData?.initialActivity == e.target.value
                                  && cloneReviewDialogData?.masterRoute == cloneReviewDialogData?.routePlan &&  cloneReviewDialogData?.initialFTC == cloneReviewDialogData?.ftcPlan
                                ){
                                  cloneReviewDialogData.schedulePlan ="P";
                                }
                                //
                                if(cloneReviewDialogData?.schedulePlan == "S" && cloneReviewDialogData?.ftcPlan== true && e.target.value != "NORM"){
                                  cloneReviewDialogData.ftcPlan = false;
                                }
                                setReviewDialogData({...cloneReviewDialogData, activityPlan: e.target.value});
                              }}
                            >
                              <MenuItem value={"NORM"}>NORMAL REPLENISHMENT(NORM)</MenuItem>
                              <MenuItem value={"PREM"}>PRODUCT REMOVAL(PREM)</MenuItem>
                              <MenuItem value={"DISP"}>DISPOSAL(DISP)</MenuItem>
                              <MenuItem value={"NOPH"} sx={{ display: 'none' }}>NON PHYSICAL(NOPH)</MenuItem>
                              <MenuItem value={"INIT"} sx={{ display: 'none' }}>INITIAL FILL(INIT)</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <Select
                              value={reviewDialogData?.routePlan}
                              label="Route"
                              onChange={(e: any)=>{
                                let cloneReviewDialogData: any = {...reviewDialogData};
                                if(cloneReviewDialogData?.masterRoute != e.target.value && cloneReviewDialogData?.schedulePlan != "S"){
                                  const alert={
                                      alertTitle:'Review Alert',
                                      alertMessage:`Marking the customer as scheduled, because route change requires customer to be in Scheduled status.`,
                                      isAlertOpen:true,
                                      alertProceedButton:false,
                                      alertDenyButton:false,
                                      alertDisable:false,
                                    };

                                  setCommonAlert(alert)
                                  cloneReviewDialogData = {...reviewDialogData, schedulePlan: "S"};
                                }else if(cloneReviewDialogData.initialStatus != "S" && cloneReviewDialogData?.schedulePlan == "S" && cloneReviewDialogData?.initialActivity == cloneReviewDialogData?.activityPlan
                                  && cloneReviewDialogData?.masterRoute == e.target.value &&  cloneReviewDialogData?.initialFTC == cloneReviewDialogData?.ftcPlan
                                ){
                                  cloneReviewDialogData = {...reviewDialogData, schedulePlan: "P"};
                                }
                                setReviewDialogData({...cloneReviewDialogData, routePlan: e.target.value});
                              }}
                            >
                              {state.filteredRoutes.map((ele: any)=>{
                                return  <MenuItem value={ele?.route}>{ele?.route}</MenuItem>
                              })}
                            </Select>
                          </TableCell>
                          <TableCell>
                            <FormControlLabel
                              label="FTC"
                              control={
                              <Checkbox
                                disabled={reviewDialogData?.activityPlan != "NORM"}
                                checked={reviewDialogData?.ftcPlan} 
                                 onClick={(e: any) => {
                                 let cloneReviewDialogData: any = {...reviewDialogData};
                                 if(cloneReviewDialogData?.schedulePlan == "P" && e.target.checked){
                                  const alert={
                                      alertTitle:'Review Alert',
                                      alertMessage:`Marking the customer as scheduled, because FTC check requires customer to be in Scheduled status.`,
                                      isAlertOpen:true,
                                      alertProceedButton:false,
                                      alertDenyButton:false,
                                      alertDisable:false,
                                    };

                                  setCommonAlert(alert)
                                  cloneReviewDialogData = {...reviewDialogData, schedulePlan: "S"};
                                }else if(cloneReviewDialogData.initialStatus != "S" && cloneReviewDialogData?.schedulePlan == "S" && cloneReviewDialogData?.initialActivity == cloneReviewDialogData?.activityPlan
                                  && cloneReviewDialogData?.masterRoute == cloneReviewDialogData?.routePlan &&  cloneReviewDialogData?.initialFTC == e.target.checked
                                ){
                                  cloneReviewDialogData = {...reviewDialogData, schedulePlan: "P"};
                                }
                                setReviewDialogData({...cloneReviewDialogData, ftcPlan: e.target.checked});
                              }} />}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
              <Grid item lg={12} xs={12} className={classes.gridMarginTop}>
                <InputLabel sx={{fontSize:20, fontWeight:"bold", marginTop:"10px"}}>Comments</InputLabel>
                <span style={{display: "inline-block", width: "850px", height:"200px", overflow: "auto"}}>
                  {reviewDialogData?.comments && reviewDialogData?.comments.map((ele: any)=>{
                    if(ele?.comments){
                      return(
                        <div id="chatBoxPlanner">
                        {ele?.role_type?.toLowerCase() === 'planner' ? (<><p style={{display: "inline-block", fontSize:"17px", fontWeight:"bold"}}>{`${ele?.user_name?.split("@")[0]}(P)`}</p> 
                            <p style={{marginLeft: "10px", display: "inline-block", fontSize:"13px"}}>{`${ele?.timestamp.split("T")[0]} : ${ele?.timestamp.split("T")[1].substr(0, 8)} (UTC)`}</p>
                            <p style={{ marginTop: "-15px", overflowWrap: "break-word"}}>{ele?.comments}</p>
                            
                            </>):
                        ((<><p style={{display: "inline-block", fontSize:"17px", fontWeight:"bold"}}>{`${ele?.user_name?.split("@")[0]}(S)`}</p>
                            <p style={{display: "inline-block", marginLeft: "10px", fontSize:"13px"}}>{`${ele?.timestamp.split("T")[0]} : ${ele?.timestamp.split("T")[1].substr(0, 8)} (UTC)`}</p>
                            <p style={{ marginTop: "-15px", overflowWrap: "break-word"}}>{ele?.comments}</p>
                          </>))}
                        </div>);
                    }else{
                      return <></>;
                    }
                  })}
                </span>
                <TextField id="outlined-basic" label="Write Comments" variant="outlined" 
                  fullWidth={true}
                  multiline
                  rows={2}
                  inputProps={{ maxLength:150}}
                  inputRef={reviewCommentRef}
                  />
              </Grid>
            </CardContent>
          </span>
          <div style={{ paddingRight: "5px", textAlign: "right" }}>
            <React.Fragment>
              <Tooltip title={"Save"}>
                <IconButton disabled={statusOflist > 0 || enableReviewSaveButton || (!reviewDialogData?.review && !isDisplayOnlyRole) } onClick={handleReviewDataSave} color="primary"  style={Pointer}>
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Cancel"}>
                <IconButton onClick={handleReviewModalClose} color="primary"  style={Pointer}>
                  <Clear />
                </IconButton>
              </Tooltip>
            </React.Fragment>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const handleDownLoadPDF=()=>{
    if(!isDownloadRoutecard){
      setIsDownloadRoutecard(true);
    setShowLoader(true);
    var customerNums: string[] = [];
    var confirmedCustomerNums: string[] = [];
    let planingItems=[]
    let HistorycustomerNums= [];
    let planningDate=new Date(props.data.planningDate).toISOString().split("T")[0]; 
    if(bulkItems.length>0){
     
     for (let index = 0; index < bulkItems.length; index++) {
        const dataIndex = bulkItems[index];
        //if (dataIndex > -1) {
          //var item = state.planningData[dataIndex];
          if(dataIndex.status=="P"){
          planingItems.push({
            "customerNumber":dataIndex.customerNum,
            "details":dataIndex.details,
            "numSalesDays":dataIndex.numSalesDays,
            "pfr":dataIndex.pfr,
            "pfrc":dataIndex.pfrc,
            "pfu":dataIndex.pfu,
            "activity":dataIndex.activity
          })}
          customerNums.push(dataIndex.customerNum);
          if(dataIndex.status=="C"){
          HistorycustomerNums.push(props.salesOrg+'_'+dataIndex.customerNum+'_'+ props.data.selectedRoute+'_'+dataIndex.plant+'_'+planningDate)
          }
      }

    }

    // for (let index = 0; index < bulkItems.length; index++) {
    //   const element = bulkItems[index];
    //     customerNums.push(element.customerNum)
    // }




    if (customerNums.length > 0) {

      let customers:string= `${customerNums.toString()}`
     
      let todayDate=new Date().toISOString().split("T")[0]; 
      if(planningDate <todayDate){
        HistoryPdf(props.salesOrg,planningDate,props.data.selectedDeliveryPlant,props.data.selectedRoute,HistorycustomerNums).then((v) => { 
          setShowLoader(false);
        });
       }
      else{
        let response = false;
          planingItems.forEach((item:any) => {
            console.log(item);
            if (item.activity ==="MULT" ) {
              response = true;
            }
        });
        if(response){
              const alert={
                alertTitle:'Download Route Card Alert',
                alertMessage:'Please uncheck the customers with activity MULT and update sap with one activity correctly.',
                isAlertOpen:true,
                alertProceedButton:false,
                alertDenyButton:false,
                alertDisable:false,
              };
              setShowLoader(false);
              setIsDownloadRoutecard(false);
            return setCommonAlert(alert);
        }else{
          customerPDFGenerate(planingItems ,props.salesOrg ,[props.data.selectedRoute],planningDate ,props.data.selectedDeliveryPlant, customers,'P')
          .then((v) => {
           setShowLoader(false);
           build_route_pdf(v, props.data.selectedDeliveryPlant)
     
          })
        }
        
      }

   
    }
  }
  setTimeout(()=>{
    setIsDownloadRoutecard(false);
  },2000);
}

  return (
    <>
   
  {props.session.is_disable?<div className="session-error">{props.session.message} <button onClick={()=>handleRefreshClick()}> Refresh</button></div>:null}
      <div ref={elementRef} id="planView" className={classes.planView + " " + classes.tablediv}>
        <TableAbstraction
          settingsKey="VS_PLN"
          options={{
            serverSide: false,
            responsive: "standard",
            selectableRows: "none",
            rowsPerPage,
            rowsPerPageOptions: [200, 500, 1000],
            draggableColumns: { enabled: true },
            sortOrder: colSort,
            fixedHeader: true,
            print: false,
            disableFuzySearch: true,
            tableHeightReducePx: 100,
       
            //columnOrder: colSequence,
            //onColumnOrderChange: onColumnOrderChange,
            //onViewColumnsChange: onViewColumnsChange,
            customToolbar,
            //onColumnSortChange: (changedColumn, direction) => {setColSort({field: changedColumn, dir: direction})},
            //onChangeRowsPerPage: (numberOfRows) => {setRowsPerPage(numberOfRows);},
          }}
          loading={gridTableLoader || props.isLoading}
          title="Planning Board"
          columns={columns}
          data={state.planningData}
          isOverdueMachineEnable={isOverdueMachine}
          setIsOverdueMachines={setIsOverdueMachine}
          overDueFilterDate={state.planningDate?.toISOString()?.split("T")[0]}
          isMapClicked={isMapClicked}
          setEssData={setEssData}
          planningDate={state.planningDate?.toISOString()?.split("T")[0]}
        />
        <Inventory data={detail} open={showInv} onClose={handleInvClose} />

        <Activity open={activity > -1} onClose={handleActClose} onSelection={handleActSel} />

        {shedule?<SheduledRoute scheduledObj={sheduleObj}  open={shedule}  onClose={handleSheduleClose}  refresh={()=>  props.reloadAll()} />:''}
       <DateAct open={dateAct > -1} onClose={handleDateActClose} onSelection={(e:any)=>handleDateActSel({"date":e,"item":{"is_table":true}})} /> 

        <Route
          open={route > -1 || routePopup}
          onClose={handleRouteClose}
          selectedRoute={props.data.selectedRoute}
          onSelection={handleRouteSel}
          routeList={state.filteredRoutes}
          toggleRoute={route}
          currentRoute={routeCustomerNum}
          multipleRoutes ={ [salesOrg,state?.planningDate?.toISOString()?.split("T")[0],routePopup]}
        />
        {/* <PlanningMapView
         data={state.planningData}
         open={showPlanMapView && modeValue === 'Normal'}
         onClose={handlePlanMapViewClose}
         onSelect={SheduleItems}
        /> */}

        {showPlanMapView && (
          <PlanningMapView
            data={state}
			warehouseLoc = {state.warehouseLocation}
            planningDate={state.planningDate}
            onClose={handlePlanMapViewClose}
            onSelect={SheduleItems}
          />
        )}
      </div>
      {/* { showPlanMapView && modeValue === 'Overlay' &&
        <OverLayPlanningMapView
        data={state}
        planningDate={state.planningDate}
        onClose={handlePlanMapViewClose}
        onSelect={SheduleItems}
        />
        } */}
      <PageInPage
        onClose={() => {
          setCustomerNotesPopup(false);
        }}
        title={"Customer Notes"}
        isOpen={customerNotesPopup}
        content={
          <TableAbstraction
            settingsKey="CUS_NOTES"
            options={{
              serverSide: false,
              responsive: "standard",
              selectableRows: "none",
              rowsPerPage: 10,
              rowsPerPageOptions: [10, 20, 30],
              draggableColumns: { enabled: true },
              sortOrder: colSort,
              fixedHeader: true,
              print: false,
              disableFuzySearch: true,
              tableHeightReducePx: 100,
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Notes`}>
                    <Button
                      className={classes.paragraphButton}
                      color="primary"
                      variant="contained"
                      onClick={() => setOpenEditWindow(true)}
                    >
                      <NoteAdd /> New Note
                    </Button>
                  </Tooltip>
                );
              },
            }}
            loading={props.isLoading}
            // title="Customer Notes"
            columns={[
              { label: "Customer #", name: "customerNum" },
              {
                label: "Note",
                name: "text",
                options: {
                  filter: true,
                },
              },
              { label: "Note Type", name: "noteType" },
              { label: "Note Status", name: "noteStatus" },
              { label: "Created By", name: "createdBy" },
              {
                label: "Valid From",
                name: "createdDt",
                options: {
                  searchable: false,
                  renderCell: (props) => {
                    return formatDate(new Date(props.row?.createdDt));
                  },
                },
              },
              { label: "Valid Until", 
                name: "validUntilDt",
                 valueGetter : (props) => {
                  return new Date(props?.row?.validUntilDt).toISOString().split('T')[0]
                }
              },
              {
                label: " ",
                name: "remove",
                disableReorder: true,
                options: {
                  filter: false,
                  setCellProps: () => ({ align: "right" }),
                  renderCell: (props) => {
                    const tableMeta = props.row;
                    if (useCompact)
                      return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                handleEdit(tableMeta);
                                setEditNote(true);
                              }}>
                              <EditIcon/>
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <IconButton
                            size="small"
                            onClick={() => {
                                setCurrent(tableMeta);
                                setConfirmDelete(true);
                              }}>
                            <DeleteIcon
                            />
                            </IconButton>
                          </Tooltip>
                        </React.Fragment>
                      );
                    else
                      return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <IconButton
                            size="small"
                              onClick={() => {
                                handleEdit(tableMeta);
                                setEditNote(true);
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <IconButton
                            size="small"
                              onClick={() => {
                                setCurrent(tableMeta);
                                // setConfirmDelete(true);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </React.Fragment>
                      );
                  },
                },
              },
            ]}
            data={customerNotes}
          />
        }
      />
      <PageInPage
        onClose={() => {
          setDisplayPIP(false);
        }}
        title={`${curKeys ? curKeys.salesOffice : ""} (${curKeys ? curKeys.customerNum : ""}) ${
          curKeys ? curKeys.customerName : ""
        }`}
        isOpen={displayPIP}
        content={
          <VendPrimeRequest
            requestNum={curKeys ? curKeys.requestNum : 0}
            onClose={() => {
              setDisplayPIP(false);
              SetVpRequests(vpRequests.filter((r) => r.requestNum !== (curKeys ? curKeys.requestNum : 0)));
            }}
          />
        }
      />
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography fontSize={12} textAlign="center">
          {hoveredNoteType}
        </Typography>
        <List>
          {hoverCustomerNotes?.map((item: any) => {
            return (
              <>
                <ListItem>
                  <ListItemText primary={item?.text ? item?.text : "---"} />
                </ListItem>
                <Divider />
              </>
            );
          })}
        </List>
      </Popover>
      <Modal open={openEditWindow} onClose={handleModalClose}>
        {modalBody}
      </Modal>
      <Modal open={reviewDialog} onClose={handleReviewModalClose}>
          { reviewCommentModalBody }
      </Modal>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorMessage !== undefined}
        onClose={() => {
          setErrorMessage(undefined);
        }}
      >
        <DialogTitle>{errorMessage?.title}</DialogTitle>
        <DialogContent>
          <Typography paragraph>{errorMessage?.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorMessage(undefined);
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you wish to delete ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleNoteDelete();
              setConfirmDelete(false);
            }}
            color="primary"
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              // setEditedRow(undefined);
              setConfirmDelete(false);
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={handleDate} onClose={() => {setHandleDate(false);setAlert("")}}>
        <DialogTitle>Notes Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>{alert}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {setHandleDate(false);setAlert("")}}
            color="primary"
          >
            Ok
            </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={clearRoutesAlert} onClose={() => setClearRoutesAlert(false)}>
        <DialogTitle>Routes Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>Customers with selected route checkbox will be unchecked !</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props.setRouteEvent('');
              props.setSalesOrgEvent('');
              setClearRoutesAlert(false);
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
          <Button
            onClick={() => {
              setSelectedRoutes([]);
              setClearRoutesAlert(false);
              props.routesSelected('');
            }}
            color="primary"
          >
            Yes Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorRouteMessage.validate === false}
        onClose={() => {
          setErrorRouteMessage({ "validate": true,
          "message":''});
          props.change();
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>Releasing Route Errors</AlertTitle>
           
                <Typography paragraph>{errorRouteMessage.message}</Typography>

          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorRouteMessage({ 
              validate: true,
              message:''});
              props.change();
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={alertReplan} onClose={() => setAlertReplan(false)}>
        <DialogTitle>Replan Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>Replan dismiss all Confirmed customers in the selected route to Schedule and allows to replan. Do you wish to proceed with Replan?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {

              setAlertReplan(false)
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
          <Button
            onClick={() => {
              handleReplanClick();
              setAlertReplan(false)
            }}
            color="primary"
          >
            Yes Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={confirmRouteReset} onClose={() => setConfirmRouteReset(false)}>
        <DialogTitle>Confirm Unscheduling</DialogTitle>
        <DialogContent>
          <DialogContentText>You are un-scheduling a customer belonging to another master route, the customer will return to the original route. Do you wish to continue?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setMoveToMasterRoute(routeItem,routeItemIndex);
              setConfirmRouteReset(false);
            }}
            color="primary"
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setConfirmRouteReset(false);
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={reviewChangeRouteDialog} onClose={() => setReviewChangeRouteDialog(false)}>
        <DialogTitle>Confirm Change Route</DialogTitle>
        <DialogContent>
          <DialogContentText>You are scheduling a customer belonging to master route {routeItem?.routePlan}, Do you wish to move the customer to {props?.data?.selectedRoute}?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              sheduleAction(routeItem, routeItemIndex);
              setIsReviewChangeRouteConfirm(false);
              setReviewChangeRouteDialog(false);
            }}
            color="primary"
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setIsReviewChangeRouteConfirm(false);
              setReviewChangeRouteDialog(false);
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmBatchRouteReset} onClose={() => setConfirmBatchRouteReset(false)}>
        <DialogTitle>Confirm Unscheduling</DialogTitle>
        <DialogContent>
          <DialogContentText>You are un-scheduling some customers belonging to another master route, the customer will return to the original route. Do you wish to continue?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setBatchMoveToMasterRoute(routeBatchItem);
              setConfirmBatchRouteReset(false);
            }}
            color="primary"
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setGridTableLoader(false);
              setConfirmBatchRouteReset(false);
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>



      <Dialog open={alertResetRoutePlan} onClose={() => setAlerResetRoutePlan(false)}>
        <DialogTitle>Reset Route Alert</DialogTitle>
        <DialogContent>
          <DialogContentText><h4>Reset Route will clear all your schedules and adjustments made for selected route and date. Please take a snapshot if
             required before proceeding with reset route. Do you wish to proceed?</h4></DialogContentText>
          

        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {

              setAlerResetRoutePlan(false)
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
          <Button
            onClick={() => {
               ResetRoutePlanProceed();
              setAlerResetRoutePlan(false)
            }}
            color="primary"
          >
            Yes Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={alertReplan} onClose={() => setAlertReplan(false)}>
        <DialogTitle>Replan Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>Replan dismiss all Confirmed customers in the selected route to Schedule and allows to replan. Do you wish to proceed with Replan?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {

              setAlertReplan(false)
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
          <Button
            onClick={() => {
              handleReplanClick();
              setAlertReplan(false)
            }}
            color="primary"
          >
            Yes Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={commonAlert.isAlertOpen} onClose={() => setCommonAlert({...commonAlert,isAlertOpen:false})}>
        <DialogTitle>{commonAlert.alertTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{commonAlert.alertMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setCommonAlert({...commonAlert,isAlertOpen:false})
            }}
            color="primary"
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={showLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </>
    // <PageInPage onClose={()=>{setDisplayPIP(false)}} title={`${curKeys?curKeys.salesOffice:''} (${curKeys?curKeys.customerNum:''}) ${curKeys?curKeys.customerName:''}`} isOpen={displayPIP} content={(<VendPrimeRequest requestNum={curKeys?curKeys.requestNum:0} onClose={()=>{setDisplayPIP(false); SetVpRequests(vpRequests.filter((r)=> r.requestNum !== (curKeys?curKeys.requestNum:0))); }} />)} />
  );
}
